import { jsx, jsxs } from 'react/jsx-runtime';
import _styled from '@emotion/styled/base';
import * as React from 'react';
import React__default from 'react';
import { SvgIcon } from '@mui/material';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw$1 = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$7 = fails$9;
var classof$4 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$7(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$4 = function (it) {
  return IndexedObject$4(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$b = function (argument) {
  return typeof argument === 'function';
};

var isCallable$a = isCallable$b;

var isObject$6 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$a(it);
};

var global$c = global$d;
var isCallable$9 = isCallable$b;

var aFunction = function (argument) {
  return isCallable$9(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$6 = fails$9;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$6(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$8 = isCallable$b;
var getBuiltIn$2 = getBuiltIn$4;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$8($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$1 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$7 = isCallable$b;
var tryToString = tryToString$1;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$7(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$2(func);
};

var isCallable$6 = isCallable$b;
var isObject$5 = isObject$6;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$6(fn = input.toString) && !isObject$5(val = fn.call(input))) return val;
  if (isCallable$6(fn = input.valueOf) && !isObject$5(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$6(fn = input.toString) && !isObject$5(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$a = global$d;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var toObject$4 = toObject$5;

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$4(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$8 = global$d;
var shared$2 = shared$3.exports;
var has$6 = has$7;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$4 = function (name) {
  if (!has$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$3 = wellKnownSymbol$4;

var TO_PRIMITIVE = wellKnownSymbol$3('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$4(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$4(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$7 = global$d;
var isObject$3 = isObject$6;

var document = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document) && isObject$3(document.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$5 = descriptors;
var fails$5 = fails$9;
var createElement = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$5 && !fails$5(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$4 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var has$5 = has$7;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$2 = isObject$6;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$2(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$3 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$3 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$4 = DESCRIPTORS$2 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$1 = {exports: {}};

var isCallable$5 = isCallable$b;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$5(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$4 = isCallable$b;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$6.WeakMap;

var nativeWeakMap = isCallable$4(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$d;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var objectHas = has$7;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$5.WeakMap;
var set, get, has$4;

var enforce = function (it) {
  return has$4(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$4 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$4 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$4,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$1 = descriptors;
var has$3 = has$7;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor;

var EXISTS = has$3(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || (DESCRIPTORS$1 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$4 = global$d;
var isCallable$3 = isCallable$b;
var has$2 = has$7;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule = internalState;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$3(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty$2(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$4) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$2(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$3(this) && getInternalState(this).source || inspectSource$1(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$2 = toLength$3;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$2(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$1 = has$7;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$7;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$4 = fails$9;
var isCallable$2 = isCallable$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$2(detection) ? fails$4(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$3 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$3;
  } else if (STATIC) {
    target = global$3[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$3[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var fails$3 = fails$9;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$5;
var IndexedObject$3 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$3(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$4 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$4({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var aCallable$1 = aCallable$3;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aCallable$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var classof$3 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$3(argument) == 'Array';
};

var wellKnownSymbol$2 = wellKnownSymbol$4;

var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$b;
var classofRaw = classofRaw$1;
var wellKnownSymbol$1 = wellKnownSymbol$4;

var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$2 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var fails$2 = fails$9;
var isCallable = isCallable$b;
var classof$1 = classof$2;
var getBuiltIn = getBuiltIn$4;
var inspectSource = inspectSource$3;

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$6;
var wellKnownSymbol = wellKnownSymbol$4;

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var IndexedObject$2 = indexedObject;
var toObject$2 = toObject$5;
var toLength$1 = toLength$3;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$2($this);
    var self = IndexedObject$2(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var fails$1 = fails$9;

var arrayMethodIsStrict$3 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$3;

var STRICT_METHOD$2 = arrayMethodIsStrict$2('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var $$3 = _export;
var forEach$1 = arrayForEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$$3({ target: 'Array', proto: true, forced: [].forEach != forEach$1 }, {
  forEach: forEach$1
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$1;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$d;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var forEach = arrayForEach;
var createNonEnumerableProperty = createNonEnumerableProperty$4;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);

var $$2 = _export;
var toObject$1 = toObject$5;
var nativeKeys = objectKeys$1;
var fails = fails$9;

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$2({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject$1(it));
  }
});

var $$1 = _export;
var IndexedObject$1 = indexedObject;
var toIndexedObject = toIndexedObject$4;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$3;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject$1 != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict$1('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$1({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var aCallable = aCallable$3;
var toObject = toObject$5;
var IndexedObject = indexedObject;
var toLength = toLength$3;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var classof = classofRaw$1;
var global$1 = global$d;

var engineIsNode = classof(global$1.process) == 'process';

var $ = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$3;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

function composeClasses(slots, getUtilityClass, classes) {
  var output = {};
  Object.keys(slots).forEach( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  function (slot) {
    output[slot] = slots[slot].reduce(function (acc, key) {
      if (key) {
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }

        acc.push(getUtilityClass(key));
      }

      return acc;
    }, []).join(" ");
  });
  return output;
}

var iconClasses = {
  root: "__private__-icon-root"
};

var useClasses = function useClasses(_ref) {
  var classes = _ref.classes;
  var slots = {
    root: ["root"]
  };
  return composeClasses(slots, function (slot) {
    return "__private__-icon-" + slot;
  }, classes);
};

var StyledIcon = /*#__PURE__*/_styled(SvgIcon, process.env.NODE_ENV === "production" ? {
  target: "e1k15kfr0"
} : {
  target: "e1k15kfr0",
  label: "StyledIcon"
})(function (_ref2) {
  var width = _ref2.width,
      height = _ref2.height;
  return {
    fill: "none",
    width: width,
    height: height
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
/**
 * create an icon component from an SVG path
 */


function createSvgIcon(path, displayName, size) {
  var Component = function Component(_a, ref) {
    var className = _a.className,
        props = __rest(_a, ["className"]);

    var classes = useClasses({
      classes: props.classes
    });
    return jsx(StyledIcon, Object.assign({}, props, {
      ref: ref,
      width: size,
      height: size,
      viewBox: "0 0 " + size + " " + size,
      className: clsx(className, classes.root, iconClasses.root + "-" + displayName)
    }, {
      children: path
    }), void 0);
  };

  if (process.env.NODE_ENV !== "production") {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = displayName + "Icon";
  }

  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

var Add24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M11 19c0 .5523.4477 1 1 1s1-.4477 1-1v-6h6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-6V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v6H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6v6Z"
}, void 0), "Add24Icon", 24);

var AddContact24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M13 9c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm6-3c-.5523 0-1 .4477-1 1v1h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1V7c0-.5523-.4477-1-1-1ZM2 18.5C2 16.567 3.567 15 5.5 15h7c1.933 0 3.5 1.567 3.5 3.5V20H2v-1.5Z"
}, void 0), "AddContact24Icon", 24);

var Alert24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9Zm-1 5c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V8Zm2 8c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z",
  clipRule: "evenodd"
}, void 0), "Alert24Icon", 24);

var Analytics24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M13 5.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v14c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5v-14ZM4.5 10c-.8284 0-1.5.6716-1.5 1.5v8c0 .8284.6716 1.5 1.5 1.5S6 20.3284 6 19.5v-8c0-.8284-.6716-1.5-1.5-1.5Zm5 3c-.8284 0-1.5.6716-1.5 1.5v5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5v-5c0-.8284-.6716-1.5-1.5-1.5Zm10-5c-.8284 0-1.5.6716-1.5 1.5v10c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5v-10c0-.8284-.6716-1.5-1.5-1.5Z"
}, void 0), "Analytics24Icon", 24);

var Announcement24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.7291 20.932c-1.072.2833-2.174-.3441-2.4613-1.4014l-.5202-1.9142L7.63 16.5905l.5202 1.9143c.2873 1.0572-.349 2.1439-1.421 2.4272Zm5.468-16.5645L5.5538 8.8584l-2.4285.6335c-.8053.2083-1.2868 1.0208-1.0756 1.8148l.7647 2.8754c.2112.794 1.0352 1.2689 1.8404 1.0607l2.4286-.6336 8.0361.7574a.7573.7573 0 0 0 .2099-.0241c.4027-.1041.6434-.5103.5378-.9074l-2.5576-9.6164a.7377.7377 0 0 0-.0802-.1896c-.2118-.3534-.674-.4705-1.0323-.2616Zm4.8721 4.6588c-.1437-.5286.1744-1.072.7105-1.2136l1.9412-.5129c.5361-.1416 1.0871.172 1.2307.7007.1437.5286-.1745 1.072-.7105 1.2136l-1.9412.513c-.5361.1416-1.0871-.1722-1.2307-.7008ZM15.884 5.0929a.9812.9812 0 0 1 0-1.4013l1.4211-1.4014c.3924-.387 1.0287-.387 1.4211 0a.9812.9812 0 0 1 0 1.4014l-1.4211 1.4013c-.3924.387-1.0287.387-1.4211 0Zm2.1703 7.9324c.1221-.5339.6599-.869 1.2013-.7486l1.9604.4361c.5414.1204.8813.6508.7592 1.1846-.1222.5339-.66.869-1.2014.7486l-1.9604-.4361c-.5414-.1204-.8813-.6508-.7591-1.1846Z"
}, void 0), "Announcement24Icon", 24);

var ArrowDown24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m18.7305 13.6809-.0914.0863-6 5-.0598.0462-.0957.0606-.0768.0384-.0895.0349-.0754.0218-.0657.0143-.0892.0118-.0885.0038-.1081-.0058-.069-.01-.1054-.025-.1248-.0458-.0769-.0383-.1043-.0666-.0512-.0403-6-5-.0914-.0863c-.3393-.363-.363-.9304-.0367-1.3221.3264-.3916.8888-.4706 1.307-.2023l.1014.0743 4.3599 3.6326-.0244-9.8623c0-.5523.4477-1 1-1 .5128 0 .9355.386.9932.8834l.0068.1166.0244 9.8623 4.3598-3.6326c.4242-.3536 1.0548-.2962 1.4084.128.3263.3917.3026.9591-.0367 1.3221Z"
}, void 0), "ArrowDown24Icon", 24);

var ArrowLeft24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m10.3181 5.2685-.0863.0913-5 6-.0462.0599-.0606.0957-.0383.0768-.035.0894-.0218.0755-.0142.0656-.0119.0893L5 12.0005l.0058.1081.01.069.025.1054.0459.1248.0383.0768.0666.1044.0402.0512 5 6 .0863.0914c.3631.3393.9305.363 1.3221.0366.3916-.3263.4706-.8887.2024-1.307l-.0744-.1014L8.1356 13l9.8623.0244c.5523 0 1-.4477 1-1 0-.5128-.386-.9355-.8833-.9933l-.1167-.0067L8.1356 11l3.6326-4.3598c.3536-.4243.2963-1.0548-.128-1.4084-.3916-.3264-.959-.3026-1.3221.0367Z"
}, void 0), "ArrowLeft24Icon", 24);

var ArrowRight24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m13.6799 5.2685.0862.0913 5 6 .0462.0599.0606.0957.0384.0768.0349.0894.0218.0755.0143.0656.0118.0893.0038.0885-.0058.1081-.01.069-.0249.1054-.0459.1248-.0383.0768-.0666.1044-.0403.0512-5 6-.0862.0914c-.3631.3393-.9305.363-1.3222.0366-.3916-.3263-.4706-.8887-.2023-1.307l.0743-.1014L15.8623 13 6 13.0244c-.5523 0-1-.4477-1-1 0-.5128.386-.9355.8834-.9933L6 11.0244 15.8623 11l-3.6326-4.3598c-.3536-.4243-.2962-1.0548.128-1.4084.3917-.3264.9591-.3026 1.3222.0367Z"
}, void 0), "ArrowRight24Icon", 24);

var ArrowUp24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m18.7305 10.3192-.0914-.0863-6-5-.0598-.0462-.0957-.0606-.0768-.0383-.0895-.035-.0754-.0218-.0657-.0142-.0892-.0119-.0885-.0038-.1081.0058-.069.01-.1054.025-.1248.0459-.0769.0383-.1043.0665-.0512.0403-6 5-.0914.0863c-.3393.3631-.363.9305-.0367 1.3221.3264.3916.8888.4706 1.307.2024l.1014-.0744 4.3599-3.6326-.0244 9.8623c0 .5523.4477 1 1 1 .5128 0 .9355-.386.9932-.8833l.0068-.1167.0244-9.8623 4.3598 3.6326c.4242.3536 1.0548.2963 1.4084-.128.3263-.3916.3026-.959-.0367-1.3221Z"
}, void 0), "ArrowUp24Icon", 24);

var Banner24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 6v13c0 .5523.4477 1 1 1s1-.4477 1-1v-4h14.8982c.8422 0 1.3072-.9774.7759-1.6308l-2.4187-2.9751a1.4166 1.4166 0 0 1-.0001-1.7873l2.4191-2.976C20.2056 4.9773 19.7406 4 18.8984 4H4c-1.1046 0-2 .8954-2 2Z",
  clipRule: "evenodd"
}, void 0), "Banner24Icon", 24);

var Blur24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M4.305 20H4v-1.1091l1.103-1.103A4.0728 4.0728 0 0 0 5 18.7v.6051L4.305 20ZM9 14.6667c-.2996 0-.5913.0331-.8717.0958l.9442-.9441a4.428 4.428 0 0 0 .8304.5838l-.2645.2645H9Zm-5 2.8099 4.4035-4.4035a4.4751 4.4751 0 0 1-.502-.9122L4 16.0624v1.4142Zm11.9193-9.0908a4.4816 4.4816 0 0 0-.5714-.8429L18.8909 4H20v.305l-4.0807 4.0808Zm.5093 2.0809a4.518 4.518 0 0 1-.0066.2448L20 7.1335V5.7193l-3.6952 3.6952c.0809.3377.1238.6901.1238 1.0522Zm-.6093 2.2617a4.4693 4.4693 0 0 1-1.6116 1.6116l-.3267.3267H15a4.08 4.08 0 0 1 .2852.01L20 9.9619V8.5477l-4.1807 4.1807Zm.6211 2.2073c.3274.1274.6336.2969.9124.5018L20 12.7903v-1.4142l-3.5596 3.5596Zm1.6387 1.1898c.2167.2634.4007.555.546.8682L20 15.6188v-1.4142l-1.9209 1.9209ZM19 18.7v.7472l1-1V17.033l-1.0471 1.0471c.031.2022.0471.4092.0471.6199ZM13.7154 6.347a4.408 4.408 0 0 1 .8999.5144L17.4766 4h-1.4142l-2.347 2.347ZM14.6482 4l-2.0415 2.0415A4.4389 4.4389 0 0 0 12 6c-.2901 0-.5734.028-.8475.0815L13.234 4h1.4142ZM4 13.234l3.66-3.66a4.5181 4.5181 0 0 0-.0886.8927c0 .1943.0124.3858.0363.5738L4 14.6482V13.234ZM20 20v-.1386L19.8614 20H20ZM11.8198 4 4 11.8198v-1.4142L10.4056 4h1.4142ZM4 8.9914 8.9914 4H7.577L4 7.5771v1.4143ZM6.163 4 4 6.163V4.7486L4.7487 4H6.163Zm9.2656 6.4667c0 1.9146-1.5351 3.4666-3.4286 3.4666s-3.4286-1.552-3.4286-3.4666S10.1065 7 12 7s3.4286 1.552 3.4286 3.4667ZM9 15.6667c-1.6569 0-3 1.358-3 3.0333V20h12v-1.3c0-1.6753-1.3431-3.0333-3-3.0333H9Z"
}, void 0), "Blur24Icon", 24);

var Bold24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.8001 19.1155h5.3157c3.0012 0 4.8842-1.5103 4.8842-4.0211 0-1.5888-.8631-2.7657-2.4323-3.315 1.0004-.51 1.6085-1.4711 1.6085-2.6872 0-2.3342-1.8242-3.7073-4.3546-3.7073H6.8001v13.7306Zm2.8834-2.4715v-3.413h2.2558c1.2357 0 2.0792.608 2.0792 1.7065 0 1.1181-.8238 1.7065-2.0792 1.7065H9.6835Zm0-5.7865V7.8368h1.8439c1.02 0 1.7653.51 1.7653 1.5104 0 .9807-.7453 1.5103-1.7653 1.5103H9.6835Z"
}, void 0), "Bold24Icon", 24);

var Bolt24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.0033 11.3345c-.3084 0-.5281-.2996-.4353-.5938l2.5835-8.192c.1355-.4296-.3675-.775-.7199-.4941L4.1023 11.8827c-.3377.2692-.1474.8134.2845.8134h4.6025c.3085 0 .5281.2995.4354.5937l-2.5835 8.1919c-.1355.4298.3675.7751.7198.4942l12.3294-9.8281c.3377-.2692.1473-.8133-.2845-.8133h-4.6026Z",
  clipRule: "evenodd"
}, void 0), "Bolt24Icon", 24);

var Bookmark16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v9c0 .824-.9408 1.2944-1.6.8l-1.8-1.35a.9999.9999 0 0 0-1.2 0L5.6 12.8c-.6592.4944-1.6.024-1.6-.8V3Z",
  clipRule: "evenodd"
}, void 0), "Bookmark16Icon", 16);

var Breakout24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 4H6c-1.1046 0-2 .8954-2 2v11c0 1.6569 1.3431 3 3 3h10c1.6569 0 3-1.3431 3-3V7c0-1.6569-1.3431-3-3-3ZM6 13v4c0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1h-4v5c0 1.1046-.8954 2-2 2H6Z",
  clipRule: "evenodd"
}, void 0), "Breakout24Icon", 24);

var Bulletlist24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.5 7.5C6.3284 7.5 7 6.8284 7 6s-.6716-1.5-1.5-1.5S4 5.1716 4 6s.6716 1.5 1.5 1.5ZM9 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm0 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm0 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm-2-6c0 .8284-.6716 1.5-1.5 1.5S4 12.8284 4 12s.6716-1.5 1.5-1.5S7 11.1716 7 12Zm-1.5 7.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5S4 17.1716 4 18s.6716 1.5 1.5 1.5Z",
  clipRule: "evenodd"
}, void 0), "Bulletlist24Icon", 24);

var BusinessCard16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6 5.9996c0 1.1044-.8954 1.9997-2 1.9997S2 7.104 2 5.9996C2 4.8953 2.8954 4 4 4s2 .8953 2 1.9996ZM2 9c-1.1046 0-2 .8954-2 2v1h8v-1c0-1.1046-.8954-2-2-2H2Zm7.5-3.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM9 10a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6A.5.5 0 0 1 9 10Z"
}, void 0), "BusinessCard16Icon", 16);

var Calendar24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 4c-.5523 0-1 .4477-1 1v1H6c-1.1046 0-2 .8954-2 2v10c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V8c0-1.1046-.8954-2-2-2h-1V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V5c0-.5523-.4477-1-1-1ZM6 18v-8h12v8H6Zm2-7c-.5523 0-1 .4477-1 1v1c0 .5523.4477 1 1 1h1c.5523 0 1-.4477 1-1v-1c0-.5523-.4477-1-1-1H8Z",
  clipRule: "evenodd"
}, void 0), "Calendar24Icon", 24);

var Camera24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V8c0-1.1046-.8954-2-2-2H4Zm13.4855 2.7087A1 1 0 0 0 17 9.5662v4.8676a1 1 0 0 0 .4855.8575l3 1.8c.6665.3999 1.5145-.0802 1.5145-.8575V7.7662c0-.7773-.848-1.2574-1.5145-.8575l-3 1.8Z",
  clipRule: "evenodd"
}, void 0), "Camera24Icon", 24);

var CameraOff24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.2929 3.2929c.3905-.3905 1.0237-.3905 1.4142 0l16 16c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0l-4.3287-4.3286C14.7873 17.3021 13.9752 18 13 18H4c-1.1046 0-2-.8954-2-2V8c0-1.1046.8954-2 2-2h.5858l-1.293-1.2929c-.3904-.3905-.3904-1.0237 0-1.4142ZM22 16.2338c0 .4302-.2598.7694-.6048.9187L17 12.7573V9.5662a1 1 0 0 1 .4855-.8575l3-1.8c.6665-.4 1.5145.0802 1.5145.8575v8.4676ZM15 8v2.7573L10.2427 6H13c1.1046 0 2 .8954 2 2Z",
  clipRule: "evenodd"
}, void 0), "CameraOff24Icon", 24);

var Captions24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.5362 4C2.6884 4 2 4.6804 2 5.5197v12.9606C2 19.3125 2.6878 20 3.5362 20h16.9276C21.3116 20 22 19.3196 22 18.4803V5.5197C22 4.6875 21.3122 4 20.4638 4H3.5362Zm7.949 9.4164c0 .1932-.0555.3997-.1666.6194-.1112.2197-.2805.429-.5082.6279-.2277.1989-.5146.359-.8606.4802-.346.1213-.7359.1819-1.1693.1819-.9217 0-1.6411-.2794-2.1584-.8382-.5173-.5588-.776-1.308-.776-2.2475 0-.6365.1185-1.1991.3553-1.6878.2367-.4887.5792-.8666 1.0272-1.1337.448-.2671.9836-.4007 1.6065-.4007.3861 0 .7404.0588 1.0628.1762s.5956.269.8196.4546c.224.1857.3952.3836.5136.5939.1184.2102.1776.4063.1776.5881 0 .1857-.0665.3429-.1994.4717-.133.1288-.2942.1932-.4836.1932-.1239 0-.2268-.0331-.3087-.0994-.082-.0663-.174-.1734-.276-.3211-.1821-.2879-.3725-.5039-.571-.6478-.1985-.144-.4508-.216-.7568-.216-.4407 0-.796.179-1.0655.537-.2695.3581-.4043.8477-.4043 1.469 0 .2917.0346.5598.1038.8041.0692.2444.1694.4528.3005.6251.1312.1724.2896.3031.4754.3921.1858.0891.3898.1336.612.1336.2987 0 .5546-.072.7677-.216.2131-.1439.4016-.3637.5655-.6592.0911-.1742.1895-.3106.2951-.4091.1057-.0985.235-.1478.388-.1478.1821 0 .3333.072.4535.216.1202.1439.1803.2974.1803.4603Zm6.6499 0c0 .1932-.0555.3997-.1667.6194-.1111.2197-.2804.429-.5081.6279-.2277.1989-.5146.359-.8606.4802-.3461.1213-.7359.1819-1.1694.1819-.9216 0-1.641-.2794-2.1583-.8382-.5173-.5588-.7759-1.308-.7759-2.2475 0-.6365.1184-1.1991.3552-1.6878.2367-.4887.5792-.8666 1.0272-1.1337.4481-.2671.9836-.4007 1.6065-.4007.3861 0 .7404.0588 1.0628.1762s.5956.269.8196.4546c.224.1857.3952.3836.5136.5939.1184.2102.1776.4063.1776.5881 0 .1857-.0665.3429-.1994.4717-.133.1288-.2942.1932-.4836.1932-.1239 0-.2268-.0331-.3087-.0994-.082-.0663-.174-.1734-.276-.3211-.1821-.2879-.3725-.5039-.571-.6478-.1985-.144-.4508-.216-.7568-.216-.4408 0-.7959.179-1.0655.537-.2696.3581-.4043.8477-.4043 1.469 0 .2917.0346.5598.1038.8041.0692.2444.1694.4528.3005.6251.1312.1724.2896.3031.4754.3921.1858.0891.3898.1336.612.1336.2987 0 .5546-.072.7677-.216.2131-.1439.4016-.3637.5655-.6592.0911-.1742.1895-.3106.2951-.4091.1056-.0985.235-.1478.388-.1478.1821 0 .3333.072.4535.216.1202.1439.1803.2974.1803.4603Z",
  clipRule: "evenodd"
}, void 0), "Captions24Icon", 24);

var Chat24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 10c0-3.3137 2.6863-6 6-6h6c3.3137 0 6 2.6863 6 6v4c0 3.3137-2.6863 6-6 6H5c-1.1046 0-2-.8954-2-2v-8Zm4 0c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1Zm1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1H8Z",
  clipRule: "evenodd"
}, void 0), "Chat24Icon", 24);

var Check16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.6402 4.2318c.4243.3536.4816.9841.128 1.4084l-5 6a1 1 0 0 1-1.4753.0669l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l1.2257 1.2257 4.299-5.1588c.3535-.4242.9841-.4816 1.4084-.128Z",
  clipRule: "evenodd"
}, void 0), "Check16Icon", 16);

var Check24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.9603 6.3477c.6364.5304.7224 1.4762.192 2.1126l-7.5 9a1.4998 1.4998 0 0 1-2.213.1004l-3-3c-.5857-.5858-.5857-1.5355 0-2.1213.5858-.5858 1.5356-.5858 2.1214 0l1.8385 1.8385 6.4485-7.7381c.5303-.6364 1.4762-.7224 2.1126-.192Z",
  clipRule: "evenodd"
}, void 0), "Check24Icon", 24);

var ChevronDown16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0L8 8.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-3 3c-.3905.3905-1.0237.3905-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142Z",
  clipRule: "evenodd"
}, void 0), "ChevronDown16Icon", 16);

var ChevronDown24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.2929 8.2929c.3605-.3605.9277-.3882 1.32-.0832l.0942.0832L12 13.585l5.2929-5.2921c.3605-.3605.9277-.3882 1.32-.0832l.0942.0832c.3605.3605.3882.9277.0832 1.32l-.0832.0942-6 6c-.3605.3605-.9277.3882-1.32.0832l-.0942-.0832-6-6c-.3905-.3905-.3905-1.0237 0-1.4142Z"
}, void 0), "ChevronDown24Icon", 24);

var ChevronLeft16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.207 4.7924c.3905.3905.3905 1.0237 0 1.4142l-2.293 2.293 2.293 2.2928c.3905.3905.3905 1.0237 0 1.4142-.3906.3905-1.0237.3905-1.4143 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142l3-3c.3906-.3905 1.0237-.3905 1.4143 0Z",
  clipRule: "evenodd"
}, void 0), "ChevronLeft16Icon", 16);

var ChevronLeft24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M15.7071 5.2929c.3605.3605.3882.9277.0832 1.32l-.0832.0942L10.415 12l5.2921 5.2929c.3605.3605.3882.9277.0832 1.32l-.0832.0942c-.3605.3605-.9277.3882-1.32.0832l-.0942-.0832-6-6c-.3605-.3605-.3882-.9277-.0832-1.32l.0832-.0942 6-6c.3905-.3905 1.0237-.3905 1.4142 0Z"
}, void 0), "ChevronLeft24Icon", 24);

var ChevronRight16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.7927 12.2071c-.3905-.3905-.3905-1.0237 0-1.4142L8.0856 8.5 5.7927 6.2071c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0Z",
  clipRule: "evenodd"
}, void 0), "ChevronRight16Icon", 16);

var ChevronRight24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M8.2929 5.2929c-.3605.3605-.3882.9277-.0832 1.32l.0832.0942L13.585 12l-5.2921 5.2929c-.3605.3605-.3882.9277-.0832 1.32l.0832.0942c.3605.3605.9277.3882 1.32.0832l.0942-.0832 6-6c.3605-.3605.3882-.9277.0832-1.32l-.0832-.0942-6-6c-.3905-.3905-1.0237-.3905-1.4142 0Z"
}, void 0), "ChevronRight24Icon", 24);

var ChevronUp16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M4.2929 10.7071c.3605.3605.9277.3882 1.32.0832l.0942-.0832L8 8.415l2.2929 2.2921c.3605.3605.9277.3882 1.32.0832l.0942-.0832c.3605-.3605.3882-.9277.0832-1.32l-.0832-.0942-3-3c-.3605-.3605-.9277-.3882-1.32-.0832l-.0942.0832-3 3c-.3905.3905-.3905 1.0237 0 1.4142Z"
}, void 0), "ChevronUp16Icon", 16);

var ChevronUp24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.2929 15.7071c.3605.3605.9277.3882 1.32.0832l.0942-.0832L12 10.415l5.2929 5.2921c.3605.3605.9277.3882 1.32.0832l.0942-.0832c.3605-.3605.3882-.9277.0832-1.32l-.0832-.0942-6-6c-.3605-.3605-.9277-.3882-1.32-.0832l-.0942.0832-6 6c-.3905.3905-.3905 1.0237 0 1.4142Z"
}, void 0), "ChevronUp24Icon", 24);

var Chrome24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.9313 6.7874C7.5513 4.902 9.7733 4 11.9793 4c2.8587 0 5.69 1.5153 7.1447 4.3694-1.8147.0006-4.656 0-6.1953 0-1.116.0006-1.8367-.0247-2.6174.386-.9173.4826-1.61 1.378-1.8513 2.4293L5.9313 6.7874ZM9.338 12c0 1.4666 1.1927 2.66 2.6587 2.66s2.6586-1.1934 2.6586-2.66c0-1.4667-1.1926-2.6607-2.6586-2.6607-1.466 0-2.6587 1.194-2.6587 2.6607Zm3.6907 3.482c-1.492.444-3.2387-.0487-4.1954-1.6994-.73-1.2606-2.6593-4.622-3.5366-6.15C4.41 8.9927 4 10.4954 4 11.9707c0 3.6321 2.484 7.1001 6.4487 7.8788l2.58-4.3674Zm1.4386-6.1427c1.2427 1.156 1.514 3.028.6714 4.4793-.634 1.0941-2.6587 4.5107-3.64 6.1654C16.2913 20.2795 20 16.4108 20 12.0027c0-.8753-.1467-1.7733-.46-2.6633h-5.0727Z"
}, void 0), "Chrome24Icon", 24);

var Circle24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.5 18.6289c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6Zm0 2c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8Z",
  clipRule: "evenodd"
}, void 0), "Circle24Icon", 24);

var Clean24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m15.1247 9.936 2.2013 1.3159c.6078.3634.8161 1.1682.4651 1.7976-.2176.3904-.5993.6216-1.0029.6542l.1642.7331c.1551.7172.283 1.3869.3838 2.0089l.0917.6062c.3167 2.2629.2339 3.8266-.2481 4.691-.4679.2424-1.1997.3128-2.096.2137.5592-1.6573.6588-3.186.2987-4.5872-.4096 1.9201-.8689 3.3879-1.3781 4.4035-1.1355-.2566-2.4327-.7273-3.7487-1.4094.7763-.6167 1.4641-1.732 2.0636-3.3454-.7955 1.4267-1.9465 2.2758-3.453 2.5473-1.0482-.6637-2.0757-1.4611-3.0102-2.3909.6972-.3077 1.432-.9154 2.2044-1.8221-1.1415.5574-2.1885.826-3.141.8058-.7876-.934-1.4762-1.9783-2.0104-3.1314 4.2796.5038 8.7973-.1501 10.461-1.33-.2014-.3875-.2094-.8704.0185-1.2792.351-.6294 1.1283-.845 1.7361-.4817ZM6.8569 7.6254l1.0447 1.2282 1.5495.3227-1.1861 1.0816-.3116 1.6045-1.0447-1.2282-1.5495-.3226 1.1861-1.0817.3116-1.6045Zm13.7654-5.0396c.4121.2464.5804.7735.3914 1.2256l-2.7176 6.501-2.883-1.7235 3.9975-5.7344c.2775-.398.801-.5142 1.2117-.2686Zm-7.8575 1.8258.6268.737.9297.1936-.7117.649-.1869.9627-.6268-.737-.9298-.1936.7117-.649.187-.9627ZM7.9653 2l.9401 1.1054 1.3946.2904-1.0675.9735-.2805 1.444-.94-1.1053-1.3946-.2904 1.0675-.9736L7.9653 2Z",
  clipRule: "evenodd"
}, void 0), "Clean24Icon", 24);

var Clear24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m13.4142 12 4.2427 4.2427c.3905.3905.3905 1.0237 0 1.4142-.3906.3905-1.0237.3905-1.4143 0L12 13.4143l-4.2426 4.2426c-.3906.3905-1.0237.3905-1.4143 0-.3905-.3905-.3905-1.0237 0-1.4142L10.5858 12 6.3431 7.7574c-.3905-.3905-.3905-1.0237 0-1.4142.3906-.3905 1.0237-.3905 1.4143 0L12 10.5858l4.2426-4.2426c.3906-.3905 1.0237-.3905 1.4143 0 .3905.3905.3905 1.0237 0 1.4142L13.4142 12Z",
  clipRule: "evenodd"
}, void 0), "Clear24Icon", 24);

var Clip24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.0672 18.6418c-.5523 0-1-.4477-1-1v-12c0-.5523.4477-1 1-1h14.0746c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1H5.0672Zm3-2h8.0746v-10H8.0672v10Zm-.8581 0h-2v-2h2v2Zm-2-4h2v-2h-2v2Zm2-4h-2v-2h2v2Zm9.7909-2h2v2h-2v-2Zm2 4h-2v2h2v-2Zm-2 4h2v2h-2v-2Z",
  clipRule: "evenodd"
}, void 0), "Clip24Icon", 24);

var Close16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.5355 3.4645c.3906.3905.3906 1.0237 0 1.4142L9.4142 8.0001l3.1213 3.1213c.3906.3905.3906 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L8 9.4143l-3.1213 3.1213c-.3905.3905-1.0237.3905-1.4142 0-.3906-.3905-.3906-1.0237 0-1.4142l3.1213-3.1213-3.1213-3.1214c-.3906-.3905-.3906-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0L8 6.5858l3.1213-3.1213c.3905-.3905 1.0237-.3905 1.4142 0Z",
  clipRule: "evenodd"
}, void 0), "Close16Icon", 16);

var Coffee24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.3162 3.0513c.524.1747.8071.741.6325 1.265l-1 3c-.1747.5239-.741.807-1.265.6324-.5239-.1746-.807-.741-.6324-1.2649l1-3c.1747-.524.741-.8071 1.265-.6325ZM6 9c-1.1046 0-2 .8954-2 2v7c0 1.1046.8954 2 2 2h8c1.1046 0 2-.8954 2-2h1c1.6569 0 3-1.3431 3-3v-1c0-1.6569-1.3431-3-3-3h-1c0-1.1046-.8954-2-2-2H6Zm10 7v-3h1c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1h-1ZM13.9487 4.3163c.1746-.524-.1085-1.0903-.6325-1.265-.5239-.1746-1.0902.1086-1.2649.6325l-1 3c-.1746.524.1085 1.0903.6325 1.265.5239.1746 1.0902-.1086 1.2649-.6326l1-3Z",
  clipRule: "evenodd"
}, void 0), "Coffee24Icon", 24);

var CollapseMenu24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "m14.68 18.7315.0862-.0913 5-6 .0462-.0599.0606-.0957.0384-.0768.0349-.0894.0218-.0755.0143-.0656.0118-.0893.0038-.0885-.0058-.1081-.01-.069-.0249-.1054-.0459-.1248-.0383-.0768-.0666-.1044-.0403-.0512-5-6-.0862-.0914c-.3631-.3393-.9305-.363-1.3222-.0366-.3916.3263-.4706.8887-.2023 1.307l.0743.1014L16.8624 11l-7.8623-.0244c-.5523 0-1 .4477-1 1 0 .5128.386.9355.8834.9933L9 12.9756 16.8624 13l-3.6326 4.3598c-.3536.4243-.2962 1.0548.128 1.4084.3917.3264.9591.3026 1.3222-.0367Z"
  }, void 0), jsx("rect", {
    width: "2",
    height: "12",
    x: "4",
    y: "6",
    fill: "currentColor",
    rx: "1"
  }, void 0)]
}, void 0), "CollapseMenu24Icon", 24);

var Contrast24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3c4.9706 0 9 4.0294 9 9s-4.0294 9-9 9-9-4.0294-9-9 4.0294-9 9-9Zm0 2c-3.866 0-7 3.134-7 7s3.134 7 7 7V5Z",
  clipRule: "evenodd"
}, void 0), "Contrast24Icon", 24);

var Copy24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M19 17h-1.4373V6.385c0-.5523-.4477-1-1-1H9V4c0-.5523.4477-1 1-1h9.0004C19.5527 3 20 3.4477 20 4v12c0 .5523-.4477 1-1 1Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1v12c0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1V8Zm-2 2c0-.5523-.4477-1-1-1H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1Zm-1 3c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h6Zm1 5c0-.5523-.4477-1-1-1H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1Z",
    clipRule: "evenodd"
  }, void 0)]
}, void 0), "Copy24Icon", 24);

var CreditCard24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 7c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v1H2V7Zm0 3v7c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-7H2Zm14 2h4v2h-4v-2Z",
  clipRule: "evenodd"
}, void 0), "CreditCard24Icon", 24);

var Cursor24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("g", {
    children: jsx("path", {
      fill: "currentColor",
      d: "M5.6809 6.9303c-.2354-.7668.4826-1.4848 1.2494-1.2494l11.6172 3.5662c.8712.2675.9598 1.4657.1375 1.8584l-4.8108 2.2973a.9999.9999 0 0 0-.4714.4714l-2.2973 4.8108c-.3927.8223-1.591.7337-1.8584-.1375L5.681 6.9303Z"
    }, void 0)
  }, void 0), jsx("defs", {}, void 0)]
}, void 0), "Cursor24Icon", 24);

var Delete24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 6c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V6Zm-2 4h12v8c0 1.1046-.8954 2-2 2H8c-1.1046 0-2-.8954-2-2v-8Z",
  clipRule: "evenodd"
}, void 0), "Delete24Icon", 24);

var Document24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 2h12c1.1046 0 2 .8954 2 2v16c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2Zm7 14c0-.5523-.4477-1-1-1H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1Zm4-4c0-.5523-.4477-1-1-1H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1Zm0-4c0-.5523-.4477-1-1-1H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1Z",
  clipRule: "evenodd"
}, void 0), "Document24Icon", 24);

var Dotgrid24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M3.5 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm-15 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm-15 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm-15 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm5 0c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Z"
}, void 0), "Dotgrid24Icon", 24);

var DoubleChevronDown16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.7071 4.2929c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142-.3905-.3905-1.0237-.3905-1.4142 0L8 6.5858l-2.2929-2.293Zm0 5c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142-.3905-.3905-1.0237-.3905-1.4142 0L8 11.5858l-2.2929-2.293Z",
  clipRule: "evenodd"
}, void 0), "DoubleChevronDown16Icon", 16);

var DoubleChevronLeft24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M19.7903 17.3871c.305.3923.2773.9595-.0832 1.32-.3905.3905-1.0237.3905-1.4142 0l-6-6-.0832-.0942c-.305-.3923-.2773-.9595.0832-1.32l6-6 .0942-.0832c.3923-.305.9595-.2773 1.32.0832l.0832.0942c.305.3923.2773.9595-.0832 1.32L14.415 12l5.2921 5.2929.0832.0942Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M11.7903 17.3871c.305.3923.2773.9595-.0832 1.32-.3905.3905-1.0237.3905-1.4142 0l-6-6-.0832-.0942c-.305-.3923-.2773-.9595.0832-1.32l6-6 .0942-.0832c.3923-.305.9595-.2773 1.32.0832l.0832.0942c.305.3923.2773.9595-.0832 1.32L6.415 12l5.2921 5.2929.0832.0942Z"
  }, void 0)]
}, void 0), "DoubleChevronLeft24Icon", 24);

var DoubleChevronRight24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.2097 6.6129c-.305-.3923-.2773-.9595.0832-1.32.3905-.3905 1.0237-.3905 1.4142 0l6 6 .0832.0942c.305.3923.2773.9595-.0832 1.32l-6 6-.0942.0832c-.3923.305-.9595.2773-1.32-.0832l-.0832-.0942c-.305-.3923-.2773-.9595.0832-1.32L9.585 12 4.2929 6.7071l-.0832-.0942Zm8 0c-.305-.3923-.2773-.9595.0832-1.32.3905-.3905 1.0237-.3905 1.4142 0l6 6 .0832.0942c.305.3923.2773.9595-.0832 1.32l-6 6-.0942.0832c-.3923.305-.9595.2773-1.32-.0832l-.0832-.0942c-.305-.3923-.2773-.9595.0832-1.32L17.585 12l-5.2921-5.2929-.0832-.0942Z",
  clipRule: "evenodd"
}, void 0), "DoubleChevronRight24Icon", 24);

var Download24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M12 3c.5128 0 .9355.386.9933.8834L13 4v7.5852l2.2929-2.2923c.3605-.3605.9277-.3882 1.32-.0832l.0942.0832c.3605.3605.3882.9277.0832 1.32l-.0832.0942-3.992 3.9919A.9973.9973 0 0 1 12 15l-.0155-.0001a.9996.9996 0 0 1-.3281-.0605.9944.9944 0 0 1-.2694-.1491l-.0014-.0013a1 1 0 0 1-.092-.0812l-.0008-.0007-4-4c-.3904-.3905-.3904-1.0237.0001-1.4142.3605-.3605.9277-.3882 1.32-.0832l.0942.0832L11 11.5852V4c0-.5523.4477-1 1-1ZM4 18c-.5523 0-1 .4477-1 1s.4477 1 1 1h16c.5523 0 1-.4477 1-1s-.4477-1-1-1H4Z"
}, void 0), "Download24Icon", 24);

var Edge24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.0382 9.6289c-2.0945-2.2672-5.9638-2.412-8.394-.611 1.1752-3.0069 4.093-5.073 7.3387-5.0168 2.9579-.0241 5.9717 1.407 7.3308 4.1404 1.4229 2.4119.6315 5.9092-2.3583 6.488-.8234.2251-4.6767.0241-3.2857-1.4873.7435-1.1014.1839-2.6209-.6315-3.5133Zm-1.455.4501c.6411-.0062.3125-.2084-.0292-.4186-.1014-.0624-.2039-.1255-.2826-.1843-.8314-.4583-1.8067-.6834-2.75-.6834-3.0778.0321-5.3042 1.9697-4.261 5.1775.7515 3.1194 3.4456 5.6278 6.6273 6.0297-1.6388-1.0371-2.6301-2.9827-2.6301-4.9202.064-2.0341 1.311-4.4218 3.3256-5.0007Zm-.4796 4.6711c-.5516-.6191-.9274-1.3587-1.0473-2.1868-.2398.3698-.4397.7718-.5836 1.206-.7355 2.2109.5436 4.9685 2.7181 5.7724 1.8706.6271 3.9731-.4904 5.3561-1.7124.0419-.0567.1419-.1611.2682-.2929.5005-.5224 1.4142-1.4761.7631-1.6045-2.4143 1.2462-5.612.8924-7.4746-1.1818Z",
  clipRule: "evenodd"
}, void 0), "Edge24Icon", 24);

var Edit24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.9896 13.9749a1 1 0 0 0-.2929.7071v2.8284c0 .5523.4477 1 1 1h2.8284a.9996.9996 0 0 0 .7071-.2929l6.7782-6.7782-4.2426-4.2426-6.7782 6.7782Zm8.1924-8.1924 4.2426 4.2426 1.4142-1.4142c.3906-.3905.3906-1.0237 0-1.4142l-2.8284-2.8284c-.3905-.3905-1.0237-.3905-1.4142 0L14.182 5.7825Z"
}, void 0), "Edit24Icon", 24);

var Embed24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M13.6177 6.0423c-.6668-.1763-1.3522.2142-1.5309.8723l-2.5882 9.5323c-.1787.658.217 1.3344.8839 1.5108.6668.1763 1.3522-.2142 1.5309-.8723l2.5882-9.5323c.1787-.658-.217-1.3344-.8839-1.5108ZM7.884 7.422a1.2221 1.2221 0 0 1 0 1.7445l-2.866 2.8284 2.866 2.8284a1.2222 1.2222 0 0 1 0 1.7446c-.4881.4817-1.2796.4817-1.7677 0l-3.75-3.7007a1.222 1.222 0 0 1 0-1.7445l3.75-3.7007c.4881-.4818 1.2796-.4818 1.7677 0Zm8.2322 9.1459a1.222 1.222 0 0 1 0-1.7445l2.8661-2.8284-2.8661-2.8285a1.222 1.222 0 0 1 0-1.7445c.4881-.4817 1.2796-.4817 1.7677 0l3.75 3.7007a1.222 1.222 0 0 1 0 1.7445l-3.75 3.7007c-.4881.4818-1.2796.4818-1.7677 0Z"
}, void 0), "Embed24Icon", 24);

var Emoji24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm14.412 2.4707a.7502.7502 0 0 0-1.0524.1326C14.5587 15.6352 13.3309 16.25 12 16.25c-1.3253 0-2.5486-.6097-3.35-1.6342a.75.75 0 1 0-1.1815.9241C8.5512 16.9242 10.2082 17.75 12 17.75c1.7993 0 3.4625-.8328 4.5446-2.2269a.7502.7502 0 0 0-.1326-1.0524ZM17 9.5c0 .8284-.6716 1.5-1.5 1.5S14 10.3284 14 9.5 14.6716 8 15.5 8s1.5.6716 1.5 1.5ZM8.5 11c.8284 0 1.5-.6716 1.5-1.5S9.3284 8 8.5 8 7 8.6716 7 9.5 7.6716 11 8.5 11Z",
  clipRule: "evenodd"
}, void 0), "Emoji24Icon", 24);

var Erazer24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M15.2373 5.5858c-.781-.781-2.0474-.781-2.8284 0l-.5229.5229 7.5758 7.5757.5228-.5228c.7811-.7811.7811-2.0474 0-2.8285l-4.7473-4.7473Zm2.8103 9.5128-7.5758-7.5757-5.886 5.886c-.781.781-.781 2.0474 0 2.8284l3.7599 3.7599h7.8118c.0358 0 .0714.0009.1068.0028H19c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.8538l2.9014-2.9014Z"
}, void 0), "Erazer24Icon", 24);

var Excel24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22 6c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V6ZM8 16c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1Zm6 0c0-.5523-.4477-1-1-1h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1Zm-6-4c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1Zm6 0c0-.5523-.4477-1-1-1h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1ZM8 8c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1Zm6 0c0-.5523-.4477-1-1-1h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1Zm5 9h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1Zm-2-4h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1Zm2-4h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1Z",
  clipRule: "evenodd"
}, void 0), "Excel24Icon", 24);

var Executives24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M16 8c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm-7.5 6C6.567 14 5 15.567 5 17.5V19h6l1-2 1 2h6v-1.5c0-1.933-1.567-3.5-3.5-3.5h-1.75L12 15.5 10.25 14H8.5Z"
}, void 0), "Executives24Icon", 24);

var Exit24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7v12h5c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1V5Z",
    clipRule: "evenodd"
  }, void 0), jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.2929 8.2929c.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L17.5858 13H12c-.5523 0-1-.4477-1-1s.4477-1 1-1h5.5858l-1.2929-1.2929c-.3905-.3905-.3905-1.0237 0-1.4142Z",
    clipRule: "evenodd"
  }, void 0)]
}, void 0), "Exit24Icon", 24);

var Expand16Icon = createSvgIcon(jsx("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9.5 3H13m0 0v3.5M13 3 9.5 6.5m-3 6.5H3m0 0V9.5M3 13l3.5-3.5"
}, void 0), "Expand16Icon", 16);

var Expand24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15 5c-.5523 0-1-.4477-1-1s.4477-1 1-1h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V6.4142l-3.2929 3.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143L17.5858 5H15ZM4 14c.5523 0 1 .4477 1 1v2.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0 .3905.3905.3905 1.0237 0 1.4142L6.4142 19H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1v-5c0-.5523.4477-1 1-1Z",
  clipRule: "evenodd"
}, void 0), "Expand24Icon", 24);

var ExpandMenu24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "m9.318 5.2685-.0862.0913-5 6-.0462.0599-.0606.0957-.0383.0768-.035.0894-.0218.0755-.0142.0656-.0119.0893L4 12.0005l.0058.1081.01.069.025.1054.0459.1248.0383.0768.0666.1044.0402.0512 5 6 .0863.0914c.363.3393.9305.363 1.3221.0366.3916-.3263.4706-.8887.2024-1.307l-.0744-.1014L7.1356 13l7.8623.0244c.5523 0 1-.4477 1-1 0-.5128-.386-.9355-.8833-.9933l-.1167-.0067L7.1356 11l3.6326-4.3598c.3536-.4243.2963-1.0548-.128-1.4084-.3916-.3264-.959-.3026-1.3221.0367Z"
  }, void 0), jsx("rect", {
    width: "2",
    height: "12",
    x: "18",
    y: "6",
    fill: "currentColor",
    rx: "1"
  }, void 0)]
}, void 0), "ExpandMenu24Icon", 24);

var Expert24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m19.6288 6.4335-.4647-.997a.7597.7597 0 0 0-.3444-.3586c-.3696-.1867-.8145-.0262-.9937.3585l-.4648.9971c-.1276.274-.3783.4634-.668.505l-1.057.1519a.7328.7328 0 0 0-.4342.2305c-.2841.308-.2745.7975.0214 1.0932l.768.7675c.2112.2111.3071.5182.2555.8183l-.1875 1.0901a.8006.8006 0 0 0 .076.5008c.1933.3768.6435.5191 1.0054.3178l.9416-.5237a.8452.8452 0 0 1 .8252 0l.9413.5236a.7177.7177 0 0 0 .4811.0792c.4039-.0753.6728-.4772.6005-.8977l-.1874-1.0902c-.0516-.3.0443-.607.2555-.8181l.768-.7676a.7841.7841 0 0 0 .2214-.4521c.0561-.423-.2279-.8132-.6342-.8716l-1.057-.1518c-.2897-.0417-.5403-.2311-.668-.505ZM13 9c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm-7.5 6C3.567 15 2 16.567 2 18.5V20h14v-1.5c0-1.933-1.567-3.5-3.5-3.5h-7Z"
}, void 0), "Expert24Icon", 24);

var ExternalLink16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.75 2a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75V9.5a.75.75 0 0 0-1.5 0v3h-9v-9h3a.75.75 0 0 0 0-1.5H2.75Zm7.125 0a.75.75 0 0 0 0 1.5h1.5643L6.7197 8.2197a.75.75 0 0 0 1.0606 1.0606L12.5 4.5607V6.125a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-.75-.75H9.875Z",
  clipRule: "evenodd"
}, void 0), "ExternalLink16Icon", 16);

var ExternalLink24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 4c-.5523 0-1 .4477-1 1v14c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1v-5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4H6V6h4c.5523 0 1-.4477 1-1s-.4477-1-1-1H5Zm9.5 0c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.0858l-6.2929 6.2929c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L18 7.4142V9.5c0 .5523.4477 1 1 1s1-.4477 1-1V5c0-.5523-.4477-1-1-1h-4.5Z",
  clipRule: "evenodd"
}, void 0), "ExternalLink24Icon", 24);

var Facebook24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 9.6302h1.5003V8.2234c0-.6206.0162-1.5771.4828-2.1698C10.4752 5.4264 11.1499 5 12.3116 5 14.2034 5 15 5.2601 15 5.2601l-.3744 2.1443s-.6252-.1737-1.2086-.1737c-.5834 0-1.1054.2017-1.1054.7639v1.6356h2.3916l-.1672 2.094h-2.2244V19H9.5003v-7.2758H8v-2.094Z",
  clipRule: "evenodd"
}, void 0), "Facebook24Icon", 24);

var Feedback24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 10c0-3.3137 2.6863-6 6-6h6c3.3137 0 6 2.6863 6 6v4c0 3.3137-2.6863 6-6 6H5c-1.1046 0-2-.8954-2-2v-8Zm8-2c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V8Zm1 9c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z",
  clipRule: "evenodd"
}, void 0), "Feedback24Icon", 24);

var File24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 2c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V7.8284a2 2 0 0 0-.5858-1.4142l-3.8284-3.8284A2 2 0 0 0 14.1716 2H6Zm8.3657 2.3657c-.504-.504-1.3657-.147-1.3657.5657V8.2a.8.8 0 0 0 .8.8h3.2686c.7128 0 1.0697-.8617.5657-1.3657l-3.2686-3.2686Z",
  clipRule: "evenodd"
}, void 0), "File24Icon", 24);

var Filter24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M4 6c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1Zm2 6c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1Zm3 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1H9Z"
}, void 0), "Filter24Icon", 24);

var Firefox24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8Zm5.3353 5.7713c-.8506-2.214-2.9733-3.07-3.6893-3.0246 2.3527.9173 2.9153 4.0393 2.7067 4.9606-.2047-1.0806-.8574-2.0113-1.248-2.2566 2.278 5.3366-3.2234 6.9766-4.902 5.1246.4326.112 1.2873.0567 1.9273-.3713.5987-.4013.6553-.4253 1.04-.4553.4573-.0354-.0273-.9374-1.026-.7847-.4107.0627-1.088.546-1.92.2273-1.0053-.384-.9733-1.756.064-1.3433.2247-.2913.0587-.842.0587-.842.3013-.276.6813-.4707.9133-.6073.152-.09.5527-.338.53-.82-.082-.064-.2133-.146-.5107-.1287-1.1573.0733-1.2346-.3453-1.3113-.5387.052-.4453.3493-1.0226.9073-1.2873-.838-.1287-1.52.2647-1.8593.7693-.5393-.116-.87-.122-1.412-.0206-.2107-.16-.444-.4467-.5853-.7874C8.24 6.208 10.018 5.3333 12 5.3333c3.9413 0 5.5087 2.8554 5.3353 4.438Z"
}, void 0), "Firefox24Icon", 24);

var FitFrame24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 6c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2V6Zm6.7071 2.2929c.3905.3905.3905 1.0237 0 1.4142L6.4142 12l2.293 2.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142l3-3c.3905-.3905 1.0237-.3905 1.4142 0ZM15.293 9.707c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L17.5858 12l-2.2929-2.2929Z",
  clipRule: "evenodd"
}, void 0), "FitFrame24Icon", 24);

var FloatingView24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2H6Zm7 8c-.5523 0-1 .4477-1 1v4c0 .5523.4477 1 1 1h4c.5523 0 1-.4477 1-1v-4c0-.5523-.4477-1-1-1h-4Z",
  clipRule: "evenodd"
}, void 0), "FloatingView24Icon", 24);

var Folder24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 4c-1.1046 0-2 .8954-2 2v2h20c0-1.1046-.8954-2-2-2h-8.4896a2 2 0 0 1-1.3287-.5052l-1.1134-.9896A2 2 0 0 0 7.7396 4H4Zm18 6H2v8c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-8Z",
  clipRule: "evenodd"
}, void 0), "Folder24Icon", 24);

var Formal24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 4C8.3431 4 7 5.3431 7 7v1H4c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-8c0-1.1046-.8954-2-2-2h-3V7c0-1.6569-1.3431-3-3-3h-4Zm5 4V7c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1v1h6Zm-8 5H4v2h16v-2H7Z",
  clipRule: "evenodd"
}, void 0), "Formal24Icon", 24);

var FreeText24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M14.7666 20H9.2333c-.8284 0-1.5-.6716-1.5-1.5s.6716-1.5 1.5-1.5H10.4V7H7.2v1.4c0 .8837-.7164 1.6-1.6 1.6C4.7163 10 4 9.2837 4 8.4V6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v2.4c0 .8836-.7163 1.6-1.6 1.6s-1.6-.7164-1.6-1.6V7h-3.2v10h1.1666c.8285 0 1.5.6716 1.5 1.5s-.6715 1.5-1.5 1.5Z"
}, void 0), "FreeText24Icon", 24);

var GenAI24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M19.4552 10.9986c-.1777.3908-.7327.3908-.9104 0l-1.1073-2.4361-2.4361-1.1073c-.3908-.1776-.3908-.7327 0-.9104l2.4361-1.1073 1.1073-2.4361c.1777-.3908.7327-.3908.9104 0l1.1073 2.4361 2.4361 1.1073c.3908.1776.3908.7327 0 .9104l-2.4361 1.1073-1.1073 2.4361Zm-10 9c-.1776.3908-.7327.3908-.9104 0L6.5 15.5l-4.4986-2.0448c-.3908-.1777-.3908-.7327 0-.9104L6.5 10.5l2.0448-4.4986c.1776-.3908.7327-.3908.9104 0L11.5 10.5l4.4986 2.0448c.3908.1777.3908.7327 0 .9104L11.5 15.5l-2.0448 4.4986Z"
}, void 0), "GenAI24Icon", 24);

var GeneralSpinner16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.9986 3.3c-2.0466 0-3.7783 1.416-4.2703 3.3484a.9.9 0 0 1-1.7443-.444C2.671 3.5058 5.097 1.5 7.9986 1.5c2.1138 0 3.9751 1.0644 5.0957 2.6856l.1767-.4421c.1853-.4637.7076-.69 1.1666-.5053.459.1847.6809.7102.4956 1.174l-.9466 2.3684c-.1548.3871-.5514.6187-.9603.5606l-2.502-.3554c-.4899-.0696-.8291-.5266-.7578-1.0209.0714-.4942.5263-.8384 1.0161-.7689l.9091.1292C10.9026 4.1032 9.5399 3.3 7.9986 3.3ZM6.232 10.0311c-.0714.4943-.5263.8385-1.0161.7689l-.9091-.1291c.789 1.2219 2.1518 2.025 3.693 2.025 2.0466 0 3.7784-1.416 4.2703-3.3484a.9.9 0 0 1 1.7444.444c-.687 2.6986-3.113 4.7044-6.0147 4.7044-2.1137 0-3.975-1.0643-5.0956-2.6855l-.1767.4422c-.1853.4637-.7076.6899-1.1666.5053-.459-.1847-.6809-.7103-.4956-1.174l.9466-2.3685c.1547-.387.5514-.6186.9603-.5605l2.502.3554c.4898.0695.829.5266.7577 1.0208Z",
  clipRule: "evenodd"
}, void 0), "GeneralSpinner16Icon", 16);

var Github24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M12 3c-4.9725 0-9 3.96-9 8.844 0 3.9082 2.5785 7.2225 6.1538 8.391.45.0832.615-.1905.615-.4253 0-.2099-.0076-.7664-.0113-1.5037-2.5035.5333-3.0315-1.1865-3.0315-1.1865-.4095-1.0207-1.0012-1.2937-1.0012-1.2937-.8153-.5483.063-.5371.063-.5371.9037.0616 1.3784.9113 1.3784.9113.8026 1.3522 2.1068.9615 2.6213.7357.081-.5722.3128-.9615.57-1.1827-1.9987-.2213-4.0995-.9818-4.0995-4.3703 0-.9652.3487-1.7542.9262-2.373-.1012-.2234-.405-1.1227.0788-2.3407 0 0 .7538-.237 2.475.9068.72-.1966 1.485-.294 2.25-.2985.765.0044 1.53.102 2.25.2984 1.71-1.1437 2.4637-.9067 2.4637-.9067.4838 1.218.1801 2.1173.09 2.3408.5738.6187.9225 1.4077.9225 2.3729 0 3.3976-2.1037 4.1453-4.1062 4.3628.315.2655.6075.8078.6075 1.6365 0 1.1835-.0112 2.1345-.0112 2.4218 0 .2317.1574.5085.6187.42C18.4237 19.0627 21 15.7463 21 11.844 21 6.96 16.9703 3 12 3Z"
}, void 0), "Github24Icon", 24);

var Globe16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 8c0 3.866 3.134 7 7 7s7-3.134 7-7-3.134-7-7-7-7 3.134-7 7Zm12.6 0c0 3.0928-2.5072 5.6-5.6 5.6-1.0562 0-2.044-.2924-2.887-.8006l.0169-.0277-.2496-3.4616a.8099.8099 0 0 0-.2338-.5132l-.79-.7935-.5107-.5363a.8099.8099 0 0 1-.212-.6932l.2355-1.3972 2.398-1.6947a.8098.8098 0 0 0 .2681-.3224l.3308-.7175A5.5995 5.5995 0 0 1 8 2.4a5.606 5.606 0 0 1 1.481.1979l-.5927.7825-.8312.7383-.8575.8005s-.3838.8406-.2638.9102c.1657.0962 1.307-.235 1.307-.235l1.0901-.143 1.1889-.2009.1313 1-.8505.3973-1.3697-.4415a.405.405 0 0 0-.1785-.016l-.9284.1256a.405.405 0 0 0-.2202.1034l-1.0401.9584a.405.405 0 0 0-.1131.4154l.3789 1.2486a.405.405 0 0 0 .2857.2744l1.2463.3235a.405.405 0 0 1 .2713.2347l.5296 1.2558a.4047.4047 0 0 1 .0275.0984l.1487 1.0117a.405.405 0 0 0 .3758.3453l.5805.0357a.405.405 0 0 0 .373-.1975l.9711-1.6354a.4046.4046 0 0 0 .0564-.2257l-.0259-.5518a.4129.4129 0 0 1 .0026-.0685l.1747-1.4161a.4047.4047 0 0 0-.0861-.3031l-.3615-.4503a.275.275 0 0 1 .4074-.3678l.2093.2066a.3698.3698 0 0 0 .536-.509l-.4455-.5009 1.6957.0591.1082-.104A5.611 5.611 0 0 1 13.6 8Z",
  clipRule: "evenodd"
}, void 0), "Globe16Icon", 16);

var Globe24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12Zm18 0c0 4.4183-3.5817 8-8 8-1.5088 0-2.92-.4177-4.1244-1.1437l.0242-.0396-.3564-4.9452a1.157 1.157 0 0 0-.3341-.7331l-1.1285-1.1335-.7296-.7662a1.1571 1.1571 0 0 1-.303-.9902l.3365-1.996 3.4258-2.421a1.157 1.157 0 0 0 .383-.4606l.4725-1.025A7.9993 7.9993 0 0 1 12 4c.7323 0 1.4417.0984 2.1156.2827l-.8465 1.1179-1.1875 1.0547-1.225 1.1435s-.5483 1.2008-.3768 1.3004c.2367.1374 1.8671-.3358 1.8671-.3358l1.5573-.2043 1.6984-.287.1875 1.4286-1.2149.5676-1.9568-.6308a.5782.5782 0 0 0-.2549-.0227l-1.3264.1793a.5785.5785 0 0 0-.3145.1478l-1.4859 1.369a.5786.5786 0 0 0-.1616.5935l.5413 1.7837a.5783.5783 0 0 0 .4082.392l1.7804.4623a.5782.5782 0 0 1 .3876.3351l.7565 1.794a.5784.5784 0 0 1 .0393.1407l.2124 1.4452a.5786.5786 0 0 0 .5369.4934l.8293.0509a.5786.5786 0 0 0 .5328-.2821l1.3874-2.3363a.5783.5783 0 0 0 .0805-.3224l-.0369-.7884a.5812.5812 0 0 1 .0037-.0978l.2496-2.023a.5787.5787 0 0 0-.1231-.4331l-.5165-.6431a.3927.3927 0 0 1 .582-.5254l.299.295a.5283.5283 0 0 0 .7658-.7271l-.6364-.7155 2.4224.0844.1545-.1485A8.0084 8.0084 0 0 1 20 12Z",
  clipRule: "evenodd"
}, void 0), "Globe24Icon", 24);

var GridView24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6Zm9 0h5v12h-5v-5.0001h5v-2h-5V6Zm-2 0H6v4.9999h5V6Zm-5 6.9999V18h5v-5.0001H6Z",
  clipRule: "evenodd"
}, void 0), "GridView24Icon", 24);

var Group24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.3704 8.2c0 1.747 1.3826 3.167 3.1003 3.1995A5.2757 5.2757 0 0 1 9.3334 10.2c0-1.8251.9287-3.4306 2.3336-4.3585C11.1045 5.3189 10.3545 5 9.531 5 7.7854 5 6.3704 6.4327 6.3704 8.2Zm3.7704 4.8001H6.7655C5.238 13.0001 4 14.2538 4 15.8002v1.2h3.0285c.297-1.7932 1.576-3.2492 3.258-3.782a5.267 5.267 0 0 1-.1457-.2181ZM8.9384 17.8c0-.2779.04-.5464.1144-.7998.34-1.1566 1.3983-2.0002 2.651-2.0002h5.5309c1.2409 0 2.2909.8276 2.6411 1.9674l.0098.0326c.0745.2535.1145.522.1145.8V19H8.9384v-1.2Zm5.5306-4.3999c1.7455 0 3.1605-1.4327 3.1605-3.2 0-1.7674-1.415-3.2-3.1605-3.2-1.7455 0-3.1606 1.4326-3.1606 3.2 0 1.7673 1.4151 3.2 3.1606 3.2Z"
}, void 0), "Group24Icon", 24);

var Hand24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M10.9997 3c0-.5523.4478-1 1-1 .5523 0 1 .4477 1 1v8.5a.5.5 0 0 0 1 0V5c0-.5523.4478-1 1-1 .5523 0 1 .4477 1 1v9.2l1.077-2.5846c.2124-.5098.7979-.7509 1.3077-.5385.5098.2125.7508.7979.5384 1.3077C17.3234 16.2232 16.1678 22 10.9997 22c-3.3137 0-6-2.6863-6-6V7c0-.5523.4478-1 1-1 .5523 0 1 .4477 1 1v4.5a.5.5 0 0 0 1 0V5c0-.5523.4478-1 1-1 .5523 0 1 .4477 1 1v5.75a.5.5 0 0 0 1 0V3Z"
}, void 0), "Hand24Icon", 24);

var Help24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9Zm.6055-6.6934h-1.7461V16h1.7461v-1.6934ZM9.8867 7.7207c-.7304.4648-1.1191 1.254-1.166 2.3672h1.6934c0-.3242.0937-.6367.2812-.9375.1914-.3008.5137-.4512.9668-.4512.4609 0 .7774.123.9492.3692.1758.2421.2637.5117.2637.8086 0 .2578-.0781.4941-.2344.7089-.0859.125-.1992.2403-.3398.3457l-.4278.334c-.4218.3282-.6835.6192-.7851.8731-.1016.25-.1641.7051-.1875 1.3652h1.582c.0039-.3125.0293-.543.0762-.6914.0742-.2344.2246-.4395.4512-.6152l.416-.3223c.4219-.3281.707-.5977.8554-.8086.254-.3476.3809-.7754.3809-1.2832 0-.8281-.293-1.4531-.8789-1.875-.582-.4219-1.3144-.6328-2.1973-.6328-.6718 0-1.2382.1484-1.6992.4453Z",
  clipRule: "evenodd"
}, void 0), "Help24Icon", 24);

var Image24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 4c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h16Zm-6.5342 5.8483c.2732-.4338.7105-.4629 1.0078-.0804l.0615.0882 3.6726 5.8763c.4099.6558.1522 1.2067-.5796 1.2629L17.5018 17H6.4982c-.7796 0-1.0898-.502-.7265-1.1416l.0668-.1078 2.6053-3.8819c.2841-.4233.8232-.5356 1.2459-.2753l.0953.0668.911.7196c.4086.3228.9415.2534 1.2517-.1333l.0675-.0948 1.4506-2.3034ZM9 8.5C9 7.672 8.328 7 7.5 7S6 7.672 6 8.5c0 .829.672 1.5 1.5 1.5S9 9.329 9 8.5Z",
  clipRule: "evenodd"
}, void 0), "Image24Icon", 24);

var Info24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9ZM11 8c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1Zm0 4c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4Z",
  clipRule: "evenodd"
}, void 0), "Info24Icon", 24);

var InformativeGallery24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.8198 3.2386c-1.3855-.1264-2.611.8943-2.7374 2.2797l-.1556 1.7058h-.3299C2.715 7.2241 2 7.9391 2 8.8211v9.5815c0 .8819.715 1.5969 1.597 1.5969h12.7753c.675 0 1.2521-.4187 1.4859-1.0106l.4338.0396c1.3854.1264 2.611-.8943 2.7374-2.2798l.8761-9.6045c.1264-1.3854-.8943-2.611-2.2797-2.7374L6.8198 3.2386Zm11.1494 13.9297.4884.0445a.6957.6957 0 0 0 .7561-.6297l.8762-9.6045a.6959.6959 0 0 0-.6297-.7561L6.6542 5.0543a.6958.6958 0 0 0-.7562.6297l-.1404 1.54h10.6147c.882 0 1.5969.715 1.5969 1.597v8.3472Zm-6.0095-5.3387c-.2374-.3054-.5866-.2822-.8047.0642l-1.1582 1.8391-.054.0758c-.2477.3087-.6731.3641-.9994.1064l-.7274-.5746-.076-.0533c-.3376-.2079-.768-.1182-.9949.2198L5.065 16.6065l-.0533.0861c-.2901.5107-.0425.9115.58.9115h8.786l.1008-.0037c.5844-.0449.7902-.4848.4629-1.0084L12.0088 11.9l-.0491-.0704Zm-5.5682-2.21c.6612 0 1.1977.5365 1.1977 1.1976 0 .6619-.5365 1.1977-1.1977 1.1977-.661 0-1.1976-.5358-1.1976-1.1977 0-.6611.5365-1.1977 1.1976-1.1977Z",
  clipRule: "evenodd"
}, void 0), "InformativeGallery24Icon", 24);

var Instagram24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.6361 16.2943c0 .74-.6018 1.3418-1.3418 1.3418H7.7057c-.74 0-1.3418-.6018-1.3418-1.3418v-5.7315h2.09A3.8157 3.8157 0 0 0 8.1724 12c0 2.1105 1.717 3.8284 3.8276 3.8284 2.1105 0 3.8276-1.7179 3.8276-3.8284 0-.5079-.1021-.9927-.2815-1.4372h2.09v5.7315Zm-7.6339-5.7315C10.45 9.9422 11.1777 9.5355 12 9.5355s1.55.4066 1.9978 1.0273c.2922.405.4667.9005.4667 1.4372 0 1.3582-1.1063 2.4637-2.4645 2.4637S9.5363 13.3582 9.5363 12c0-.5367.1745-1.0322.4659-1.4372Zm7.0684-3.9494.3095-.0009v2.3731l-2.3658.0075-.0082-2.3732 2.0645-.0065ZM16.2943 5H7.7057C6.214 5 5 6.2133 5 7.7057v8.5886C5 17.7867 6.2141 19 7.7057 19h8.5886C17.7859 19 19 17.7867 19 16.2943V7.7057C19 6.2133 17.7859 5 16.2943 5Z",
  clipRule: "evenodd"
}, void 0), "Instagram24Icon", 24);

var Integrations24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.5 10C8.433 10 10 8.433 10 6.5S8.433 3 6.5 3 3 4.567 3 6.5 4.567 10 6.5 10Zm10.9341-6.2403c-.1919-.3359-.6763-.3359-.8682 0L13.4275 9.252c-.1905.3334.0502.7481.4341.7481h6.2768c.3839 0 .6246-.4147.4341-.748l-3.1384-5.4923ZM3 15c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1H4c-.5523 0-1-.4477-1-1v-5Zm14.3536-1.3964a.5.5 0 0 0-.7072 0l-3.5428 3.5428a.5.5 0 0 0 0 .7072l3.5428 3.5428a.5.5 0 0 0 .7072 0l3.5428-3.5428a.5.5 0 0 0 0-.7072l-3.5428-3.5428Z",
  clipRule: "evenodd"
}, void 0), "Integrations24Icon", 24);

var InteractiveRoom24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m17.8817 9.1664 3-1.9862c.4341-.2874 1.0628-.2242 1.4043.141.1386.1484.214.3317.214.5204v8.3168c0 .4648-.4477.8416-1 .8416-.2243 0-.442-.0634-.6183-.1801l-3-1.9862c-.241-.1596-.3817-.4034-.3817-.6615V9.8278c0-.258.1407-.5019.3817-.6614ZM6.5161 7.7143c-1.4965 0-2.7096 1.1513-2.7096 2.5714v6h7.6774c1.4965 0 2.7096-1.1513 2.7096-2.5714v-3.4286c0-1.4201-1.2131-2.5714-2.7096-2.5714H6.5161ZM2 10.2857C2 7.9187 4.022 6 6.5161 6h4.9678C13.9781 6 16 7.9188 16 10.2857v3.4286C16 16.0812 13.9781 18 11.4839 18H2.9032C2.4044 18 2 17.6162 2 17.1429v-6.8572ZM7.4221 12H6.0673c-.4989 0-.9032.3838-.9032.8572 0 .4518.3684.822.8358.8547l.0674.0024H7.422c.4989 0 .9032-.3838.9032-.8571 0-.4519-.3684-.8221-.8358-.8548L7.4221 12ZM5.967 9.4286h5.6201l.0599.0023c.4154.0327.743.403.743.8548 0 .4734-.3595.8571-.8029.8571h-5.62l-.06-.0023c-.4154-.0327-.743-.4029-.743-.8548 0-.4734.3595-.8571.803-.8571Z",
  clipRule: "evenodd"
}, void 0), "InteractiveRoom24Icon", 24);

var Internet24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.285 10.09c-.4585-.6286-.3525-1.5353.2368-2.0252 2.4364-2.025 5.4453-3.1054 8.5321-3.0636 3.0868.0418 6.0677 1.2033 8.4525 3.2936.5769.5056.6602 1.4149.186 2.0309-.4742.616-1.3262.7054-1.9031.1998-1.9105-1.6746-4.2986-2.6051-6.7715-2.6386-2.473-.0335-4.8835.832-6.8353 2.4544-.5894.4898-1.4388.3773-1.8974-.2513Zm3.7734 4.1043c-.4034-.6702-.2212-1.5631.4072-1.9941 1.3458-.9234 2.9161-1.4041 4.5155-1.3825 1.5993.0217 3.1571.5448 4.4794 1.5043.6173.4479.7771 1.3454.357 2.0045-.4202.6591-1.2612.8303-1.8785.3824-.8838-.6413-1.925-.991-2.9941-1.0055-1.069-.0144-2.1186.3069-3.0182.9241-.6283.431-1.4648.2371-1.8683-.4332Zm3.9348 4.36c-.5311-.5818-.5216-1.511.0212-2.0753l.0098-.0103c.5428-.5643 1.4133-.5502 1.9444.0315.5312.5818.5217 1.511-.0211 2.0754l-.0098.0102c-.5428.5644-1.4134.5502-1.9445-.0315Z",
  clipRule: "evenodd"
}, void 0), "Internet24Icon", 24);

var Invisible24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M22 12c-1.5727-4.39-5.4545-7-10-7-1.6458 0-3.2045.3422-4.5982.987l1.8423 1.8436A4.9692 4.9692 0 0 1 12 7c2.7556 0 5 2.2444 5 5a4.97 4.97 0 0 1-.8299 2.7549l2.2053 2.2048C19.9866 15.7667 21.2534 14.0839 22 12ZM7.83 9.2451 5.6246 7.0403C4.0134 8.2333 2.7466 9.9162 2 12c1.5727 4.39 5.4546 7 10 7 1.6458 0 3.2045-.3421 4.5982-.9871l-1.8433-1.8428A4.97 4.97 0 0 1 12 17c-2.7556 0-5-2.2444-5-5 0-1.0169.3057-1.9643.83-2.7549Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "m9.2926 10.709 3.9994 3.998A2.981 2.981 0 0 1 12 15c-1.6533 0-3-1.3467-3-3 0-.4618.105-.8997.2926-1.291ZM15 12c0-1.6533-1.3467-3-3-3a2.98 2.98 0 0 0-1.292.293l3.999 3.999A2.981 2.981 0 0 0 15 12Z"
  }, void 0)]
}, void 0), "Invisible24Icon", 24);

var Italic24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m12.48 19.0001 1.48-9.88h-2.92L9.56 19h2.92Zm.46-14.44c-.96 0-1.76.8-1.76 1.74 0 .9.7 1.66 1.66 1.66.94 0 1.74-.8 1.74-1.74 0-.86-.72-1.66-1.64-1.66Z"
}, void 0), "Italic24Icon", 24);

var Keylines24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M19.4552 10.9986c-.1777.3908-.7327.3908-.9104 0l-1.1073-2.4361-2.4361-1.1073c-.3908-.1776-.3908-.7327 0-.9104l2.4361-1.1073 1.1073-2.4361c.1777-.3908.7327-.3908.9104 0l1.1073 2.4361 2.4361 1.1073c.3908.1776.3908.7327 0 .9104l-2.4361 1.1073-1.1073 2.4361Zm-10 9c-.1776.3908-.7327.3908-.9104 0L6.5 15.5l-4.4986-2.0448c-.3908-.1777-.3908-.7327 0-.9104L6.5 10.5l2.0448-4.4986c.1776-.3908.7327-.3908.9104 0L11.5 10.5l4.4986 2.0448c.3908.1777.3908.7327 0 .9104L11.5 15.5l-2.0448 4.4986Zm7.539-.0921a.2.2 0 0 1 .0993.0993l.7244 1.5936c.0711.1564.2931.1564.3642 0l.7244-1.5936a.2.2 0 0 1 .0993-.0993l1.5936-.7244c.1564-.0711.1564-.2931 0-.3642l-1.5936-.7244a.2.2 0 0 1-.0993-.0993l-.7244-1.5936c-.0711-.1564-.2931-.1564-.3642 0l-.7244 1.5936a.2.2 0 0 1-.0993.0993l-1.5936.7244c-.1564.0711-.1564.2931 0 .3642l1.5936.7244Z"
}, void 0), "Keylines24Icon", 24);

var Laser24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.5277 3.6483c.4691-.3127 1.0165.2693.6756.7184L12.1669 11h.659l.0001-.0001h3.3682c1.2888 0 1.9775 1.5179 1.1289 2.4877l-4.8219 5.5108c-.4561.6081-1.1827 1.0015-2.0013 1.0015-1.3807 0-2.5-1.1193-2.5-2.5 0-.6882.278-1.3115.728-1.7636L10.2302 14H5.9544c-1.4841 0-2.067-1.9249-.832-2.7481l11.4053-7.6036ZM10.5 19c.8284 0 1.5-.6715 1.5-1.5 0-.8284-.6716-1.5-1.5-1.5S9 16.6716 9 17.5c0 .8285.6716 1.5 1.5 1.5Z",
  clipRule: "evenodd"
}, void 0), "Laser24Icon", 24);

var Light24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 2c0-.5523.4477-1 1-1s1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V2Zm5 10c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm7 0c0-.5523-.4477-1-1-1h-3c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1ZM5 11c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h3Zm7 7c-.5523 0-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1v-3c0-.5523-.4477-1-1-1ZM4.2218 5.636c-.3905-.3905-.3905-1.0236 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l2.1213 2.1214c.3906.3905.3906 1.0237 0 1.4142-.3905.3905-1.0236.3905-1.4142 0L4.2218 5.636Zm15.5564-1.414c-.3906-.3905-1.0237-.3905-1.4143 0l-2.1213 2.1213c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0l2.1214-2.1213c.3905-.3905.3905-1.0237 0-1.4142ZM6.3432 16.2426c.3904-.3905 1.0236-.3905 1.4141 0 .3906.3906.3906 1.0237 0 1.4142L5.636 19.7782c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3906-.3905-1.0237 0-1.4143l2.1213-2.1213Zm9.8994 0c-.3905.3905-.3905 1.0237 0 1.4142l2.1213 2.1213c.3906.3906 1.0237.3906 1.4143 0 .3905-.3905.3905-1.0237 0-1.4142l-2.1214-2.1213c-.3905-.3905-1.0236-.3905-1.4142 0Z",
  clipRule: "evenodd"
}, void 0), "Light24Icon", 24);

var Like24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6 20H2v-9h4v9Zm16-8c0-1.1406-1.0242-2.06-2.5-2-1.0233.0417-2.4475-.11-3.5417-.6825C16.7133 6.2708 16.5317 2 14.5517 2c-1.3284 0-1.58 1.5058-1.9792 2.8908C11.555 8.4258 9.9792 10.2767 8 11v9c3.6517.5842 5.1208 2 8.5875 2C19.2525 22 21 20.2758 21 19.5c.5-2.5 1-4.5905 1-7.5Z"
}, void 0), "Like24Icon", 24);

var LikeHollow24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m13.6392 10.3613.3779-1.5249c.2344-.946.3587-2.0186.3527-2.9751-.9327 3.0066-2.3619 5.171-4.3698 6.3876v6.1239c.969.2454 1.7861.5295 2.502.7784.1738.0605.3417.1189.5044.1741 1.1687.397 2.1642.6747 3.5811.6747.8971 0 1.6105-.2903 2.0745-.6085.1885-.1292.3139-.2481.386-.3293.0534-.267.1062-.5266.1578-.7805.4346-2.138.787-3.8717.7941-6.2101-.053-.0302-.1815-.0829-.4185-.0733M8 20c1.569.251 2.7352.6556 3.83 1.0354 1.453.5041 2.7804.9646 4.7575.9646C19.2525 22 21 20.2758 21 19.5c.0556-.278.1112-.5509.1661-.8204C21.605 16.525 22 14.586 22 12c0-1.1406-1.0242-2.06-2.5-2-1.0233.0417-2.4475-.11-3.5417-.6825C16.7133 6.2708 16.5317 2 14.5517 2c-1.1847 0-1.513 1.1977-1.8533 2.4393-.0413.1505-.0827.3017-.1259.4515C11.555 8.4258 9.9792 10.2767 8 11v9Zm-2 0v-9H2v9h4Z",
  clipRule: "evenodd"
}, void 0), "LikeHollow24Icon", 24);

var Line24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.6362 18.9923c-.3905-.3906-.3905-1.0237 0-1.4143L16.9499 6.2643c.3905-.3905 1.0237-.3905 1.4142 0 .3905.3906.3905 1.0237 0 1.4143L7.0504 18.9923c-.3905.3905-1.0237.3905-1.4142 0Z",
  clipRule: "evenodd"
}, void 0), "Line24Icon", 24);

var Linegrid24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.0337 4h-2v2h-2v2h2v3h-2v2h2v3h-2v2h2v2h2v-2h3v2h2v-2h3v2h2v-2h2v-2h-2v-3h2v-2h-2V8h2V6h-2V4h-2v2h-3V4h-2v2h-3V4Zm8 12v-3h-3v3h3Zm-5 0v-3h-3v3h3Zm0-5h-3V8h3v3Zm5 0h-3V8h3v3Z",
  clipRule: "evenodd"
}, void 0), "Linegrid24Icon", 24);

var Link16Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M10.4771 3.483c.5633-.5632 1.4765-.5632 2.0399 0 .5633.5634.5633 1.4767 0 2.04L9.6028 8.437c-.5633.5633-1.4766.5633-2.0399 0-.4024-.4023-1.0547-.4023-1.457 0-.4024.4024-.4024 1.0547 0 1.4571 1.368 1.368 3.586 1.368 4.954 0L13.974 6.98c1.368-1.368 1.368-3.586 0-4.954-1.368-1.368-3.586-1.368-4.954 0l-.5828.5827c-.4024.4024-.4024 1.0548 0 1.4571.4023.4024 1.0547.4024 1.457 0l.5829-.5828Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M6.3972 7.5629c.5633-.5633 1.4766-.5633 2.0399 0 .4024.4023 1.0547.4023 1.457 0 .4024-.4024.4024-1.0547 0-1.4571-1.368-1.368-3.586-1.368-4.954 0L2.026 9.0199c-1.368 1.3681-1.368 3.5861 0 4.9541 1.368 1.368 3.586 1.368 4.954 0l.5828-.5828c.4024-.4024.4024-1.0548 0-1.4571-.4023-.4024-1.0547-.4024-1.457 0l-.5829.5828c-.5633.5633-1.4765.5633-2.0398 0-.5633-.5633-.5633-1.4766 0-2.0399l2.9141-2.9141Z"
  }, void 0)]
}, void 0), "Link16Icon", 16);

var Link24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M15.0052 6.52c.6835-.6835 1.7915-.6835 2.4749 0 .6834.6834.6834 1.7914 0 2.4748l-3.5355 3.5356c-.6834.6834-1.7915.6834-2.4749 0-.4882-.4882-1.2796-.4882-1.7678 0-.4881.4881-.4881 1.2796 0 1.7677 1.6598 1.6598 4.3507 1.6598 6.0104 0l3.5356-3.5355c1.6597-1.6597 1.6597-4.3507 0-6.0104-1.6597-1.6598-4.3507-1.6598-6.0104 0l-.7071.707c-.4882.4882-.4882 1.2797 0 1.7679.4881.4881 1.2796.4881 1.7677 0l.7071-.7072Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M10.0554 11.4697c.6834-.6834 1.7915-.6834 2.4749 0 .4881.4881 1.2796.4881 1.7678 0 .4881-.4882.4881-1.2796 0-1.7678-1.6598-1.6597-4.3507-1.6597-6.0105 0l-3.5355 3.5356c-1.6597 1.6597-1.6597 4.3506 0 6.0104 1.6597 1.6597 4.3507 1.6597 6.0104 0l.7071-.7071c.4882-.4882.4882-1.2797 0-1.7678-.4881-.4882-1.2796-.4882-1.7677 0l-.7071.7071c-.6835.6834-1.7915.6834-2.475 0-.6833-.6834-.6833-1.7915 0-2.4749l3.5356-3.5355Z"
  }, void 0)]
}, void 0), "Link24Icon", 24);

var LinkedIn24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 19h-2.8732v-4.57c0-1.1962-.4494-2.0128-1.4377-2.0128-.756 0-1.1763.551-1.372 1.0821-.0734.1907-.0619.4562-.0619.7217V19H9.4087s.0367-8.0953 0-8.8312h2.8465v1.386c.1681-.606 1.0777-1.4709 2.5292-1.4709 1.8008 0 3.2156 1.2703 3.2156 4.0056V19ZM6.5302 9.0642H6.512C5.5947 9.0642 5 8.389 5 7.5333 5 6.661 5.6122 6 6.5478 6c.9348 0 1.5096.6593 1.528 1.5308 0 .8558-.5932 1.5334-1.5456 1.5334ZM5.328 19h2.5338v-8.8312H5.328V19Z",
  clipRule: "evenodd"
}, void 0), "LinkedIn24Icon", 24);

var LiveBroadcast24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M15.3863 4.094c.3817-.3993 1.0147-.4135 1.4139-.0319C18.9567 6.1237 20.2 8.9711 20.2 12.0143c0 3.0251-1.2284 5.8569-3.3623 7.9162-.3974.3835-1.0305.3722-1.414-.0252-.3835-.3974-.3722-1.0305.0252-1.414 1.7472-1.6861 2.7511-4.0004 2.7511-6.477 0-2.4915-1.0161-4.8185-2.7819-6.5065-.3992-.3816-.4134-1.0146-.0318-1.4138Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M12.5729 6.9521c.3777-.403 1.0106-.4234 1.4135-.0457C15.3886 8.2208 16.2 10.0538 16.2 12.0143c0 1.96-.811 3.7925-2.2125 5.1069-.4029.3778-1.0357.3574-1.4135-.0454-.3778-.4029-.3575-1.0357.0454-1.4135 1.0024-.9401 1.5806-2.2466 1.5806-3.648 0-1.4018-.5785-2.7086-1.5814-3.6487-.4029-.3777-.4234-1.0106-.0457-1.4135ZM4.836 16.8187l6.1358-3.8083a1.1946 1.1946 0 0 0 .3816-.3789c.3513-.5581.1804-1.2933-.3816-1.6421L4.836 7.1811A1.2062 1.2062 0 0 0 4.2 7C3.5373 7 3 7.5335 3 8.1917v7.6165c0 .2233.0632.4422.1824.6316.3513.5581 1.0916.7277 1.6536.3789Z"
  }, void 0)]
}, void 0), "LiveBroadcast24Icon", 24);

var Lock16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.667 2c-1.1046 0-2 .8954-2 2v3.3333c-1.1046 0-2 .8955-2 2V12c0 1.1046.8954 2 2 2h6.6667c1.1045 0 2-.8954 2-2V9.3333c0-1.1045-.8955-2-2-2V4c0-1.1046-.8955-2-2-2H6.667Zm3.3333 5.3333V4a.6666.6666 0 0 0-.6666-.6667H6.667A.6667.6667 0 0 0 6.0003 4v3.3333h4Z",
  clipRule: "evenodd"
}, void 0), "Lock16Icon", 16);

var Lock24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3C8.3431 3 7 4.3431 7 6v5H6c-1.1046 0-2 .8954-2 2v6c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2v-6c0-1.1046-.8954-2-2-2h-1V6c0-1.6569-1.3431-3-3-3h-4Zm5 8V6c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1v5h6Z",
  clipRule: "evenodd"
}, void 0), "Lock24Icon", 24);

var Mail24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22 6c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V6Zm-3.1056 2.5528c-.247-.494-.8477-.6942-1.3416-.4473L12 10.881 6.4472 8.1055l-.1073-.046c-.4707-.1708-1.005.0346-1.2344.4933-.247.494-.0467 1.0946.4473 1.3416l6 3 .1234.0517a.9997.9997 0 0 0 .771-.0517l6-3 .1013-.0582c.419-.274.5752-.8247.3459-1.2834Z",
  clipRule: "evenodd"
}, void 0), "Mail24Icon", 24);

var Marker24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M15 4 9 6.4286V9h6V4Zm-8 7c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1v1H7v-1Zm-2 3c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1v7H5v-7Z"
}, void 0), "Marker24Icon", 24);

var Martini24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.1843 3.217c-.4783-.2762-1.0899-.1124-1.366.366L13.8454 7H4.4341c-1.0005 0-1.381 1.3065-.537 1.8437L11 13.3637v5.6364H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4v-5.6364l7.1028-4.52c.844-.537.4636-1.8436-.5369-1.8436h-3.4111l1.3955-2.4172c.2762-.4783.1123-1.0899-.366-1.366Z",
  clipRule: "evenodd"
}, void 0), "Martini24Icon", 24);

var Menu24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M4 6c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1Zm0 6c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1Zm1 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h14c.5523 0 1-.4477 1-1s-.4477-1-1-1H5Z"
}, void 0), "Menu24Icon", 24);

var Microphone16Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M6 4c0-1.1046.8954-2 2-2s2 .8954 2 2v3.3333c0 1.1046-.8954 2-2 2s-2-.8954-2-2V4Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M4 6a.6667.6667 0 0 1 .6667.6667v.6666c0 1.841 1.4924 3.3334 3.3333 3.3334 1.841 0 3.3333-1.4924 3.3333-3.3334v-.6666a.6667.6667 0 0 1 1.3334 0v.6666c0 2.3516-1.7393 4.2969-4.0017 4.6197a.6767.6767 0 0 1 .0017.047v1.3333a.6667.6667 0 1 1-1.3334 0V12a.6767.6767 0 0 1 .0017-.047c-2.2624-.3228-4.0017-2.2681-4.0017-4.6197v-.6666A.6667.6667 0 0 1 4 6Z"
  }, void 0)]
}, void 0), "Microphone16Icon", 16);

var Microphone24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M9 6c0-1.6569 1.3431-3 3-3s3 1.3431 3 3v5c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3V6Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M6 9c.5523 0 1 .4477 1 1v1c0 2.7614 2.2386 5 5 5s5-2.2386 5-5v-1c0-.5523.4477-1 1-1s1 .4477 1 1v1c0 3.5273-2.609 6.4453-6.0024 6.9295.0016.0233.0024.0468.0024.0705v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.0237.0008-.0472.0024-.0705C7.609 17.4453 5 14.5273 5 11v-1c0-.5523.4477-1 1-1Z"
  }, void 0)]
}, void 0), "Microphone24Icon", 24);

var MicrophoneMuted16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.0953 3.3882 10 7.293V4c0-1.1046-.8954-2-2-2-.8912 0-1.6462.5829-1.9047 1.3882ZM2.862 2.8619a.6667.6667 0 0 1 .9427 0l9.3334 9.3333a.6667.6667 0 0 1-.9428.9428l-1.7993-1.7993a4.6348 4.6348 0 0 1-1.731.6142.6796.6796 0 0 1 .0017.0471v1.3333a.6667.6667 0 1 1-1.3334 0V12a.6796.6796 0 0 1 .0017-.0471c-2.2624-.3228-4.0017-2.268-4.0017-4.6196v-.6667a.6667.6667 0 0 1 1.3334 0v.6667c0 1.841 1.4924 3.3333 3.3333 3.3333a3.32 3.32 0 0 0 1.4113-.3126L8.3585 9.3013A2.0115 2.0115 0 0 1 8 9.3332c-1.1046 0-2-.8954-2-2v-.3905l-3.138-3.138a.6667.6667 0 0 1 0-.9428Zm8.9909 7.1053a4.6455 4.6455 0 0 0 .8138-2.634v-.6666a.6667.6667 0 0 0-1.3334 0v.6667a3.3181 3.3181 0 0 1-.4465 1.6678l.9661.9661Z"
}, void 0), "MicrophoneMuted16Icon", 16);

var MicrophoneMuted24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M14.8291 12.0006 9 6.1716V6c0-1.6569 1.3431-3 3-3s3 1.3431 3 3v5c0 .3509-.0602.6877-.1709 1.0006Zm-9.122-7.7077c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142L9 10.4142V11c0 1.6569 1.3431 3 3 3a3.014 3.014 0 0 0 .5377-.0481l1.5792 1.5792A4.982 4.982 0 0 1 12 16c-2.7614 0-5-2.2386-5-5v-1c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 3.5273 2.609 6.4453 6.0024 6.9295A1.0288 1.0288 0 0 0 11 18v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2c0-.0237-.0008-.0472-.0024-.0705a6.9563 6.9563 0 0 0 2.5964-.9213l2.6989 2.6989c.3905.3905 1.0237.3905 1.4142 0 .3905-.3905.3905-1.0237 0-1.4142l-14-14ZM19 11c0 1.4658-.4505 2.8264-1.2207 3.9509l-1.4492-1.4492C16.7562 12.7659 17 11.9114 17 11v-1c0-.5523.4477-1 1-1s1 .4477 1 1v1Z"
}, void 0), "MicrophoneMuted24Icon", 24);

var Minimize24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M21 9c0-.5523-.4477-1-1-1h-2.5858l3.2929-3.2929c.3905-.3905.3905-1.0237 0-1.4142-.3905-.3905-1.0237-.3905-1.4142 0L16 6.5858V4c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1h5c.5523 0 1-.4477 1-1ZM8 17.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1v-5c0-.5523-.4477-1-1-1H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.5858l-3.293 3.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L8 17.4142Z"
}, void 0), "Minimize24Icon", 24);

var Minus24Icon = createSvgIcon(jsx("rect", {
  width: "14",
  height: "2",
  x: "5",
  y: "11",
  fill: "currentColor",
  rx: "1"
}, void 0), "Minus24Icon", 24);

var Mobile24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19 3.8101C19 2.8088 18.1019 2 16.9941 2H7.0059C5.897 2 5 2.8104 5 3.8101V20.19C5 21.1912 5.898 22 7.0059 22h9.9882C18.1029 22 19 21.1896 19 20.1899V3.8101ZM11 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2Z",
  clipRule: "evenodd"
}, void 0), "Mobile24Icon", 24);

var MoreHorizontal24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm6 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm6 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Z",
  clipRule: "evenodd"
}, void 0), "MoreHorizontal24Icon", 24);

var MoreVertical24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M14 6c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm0 6c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm-2 8c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
}, void 0), "MoreVertical24Icon", 24);

var NoAccess24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.6306 17.9861C14.5721 18.6295 13.3293 19 12 19c-3.866 0-7-3.134-7-7 0-1.5473.502-2.9773 1.352-4.136l9.2786 10.1221Zm1.5457-1.2737L7.7544 6.434C8.932 5.5344 10.4036 5 12 5c3.866 0 7 3.134 7 7 0 1.815-.6908 3.4687-1.8237 4.7124ZM21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9Z",
  clipRule: "evenodd"
}, void 0), "NoAccess24Icon", 24);

var None24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6.5c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2v-12Zm13.9815 1.727c.0122.0893.0185.1804.0185.273v8c0 1.1046-.8954 2-2 2H8c-.1116 0-.221-.0091-.3276-.0267L17.9815 8.2271Zm-1.2416-1.5857L6.1234 17.1931A1.9957 1.9957 0 0 1 6 16.5v-8c0-1.1046.8954-2 2-2h8c.2614 0 .511.0501.7399.1413Z",
  clipRule: "evenodd"
}, void 0), "None24Icon", 24);

var Notes24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2H6Zm1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1H7Zm-1 5c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1Zm12 2.7243V17.7a.3.3 0 0 1-.3.3h-2.9757c-.2673 0-.4012-.3231-.2122-.5121l2.9758-2.9758c.189-.189.5121-.0551.5121.2122Z",
  clipRule: "evenodd"
}, void 0), "Notes24Icon", 24);

var Notification24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M17.6346 7.3115C17.2475 4.2804 14.8208 2.0095 11.9585 2c-2.8623-.0095-5.276 2.2453-5.6456 5.274l-.9175 6.4755-.9-.003c-.8284-.0027-1.498.7122-1.4954 1.5969.0025.8847.6762 1.6041 1.5046 1.6069l15 .0497c.8284.0027 1.4979-.7122 1.4954-1.5969-.0026-.8847-.6762-1.6041-1.5046-1.6068l-.9-.003-.9608-6.4818ZM12.0188 22c1.8409.0054 3.3287-1.4041 3.3231-3.1481l-6.6667-.0196.0063.1855c.1067 1.658 1.5621 2.9769 3.3373 2.9822Z"
}, void 0), "Notification24Icon", 24);

var OrderedList24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.0246 4v4h-.9V5H4.1V4a70.923 70.923 0 0 1 1.2323-.002c.2057.001.424.002.6923.002ZM9 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm0 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm0 6c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1Zm-4.1067-6.7893c0-.4007.2233-.7094.6766-.7094.427 0 .6437.2759.6437.5846 0 .2956-.1445.5189-.5058.7357l-.7028.4204c-.762.4597-.9984 1.0706-1.005 1.8194h3.1529v-.7816H5.11c.0657-.1642.2036-.2825.3678-.3876l.821-.4992c.5255-.3218.8277-.7685.8277-1.3202 0-.7423-.5846-1.3729-1.537-1.3729-.9919 0-1.5568.6766-1.5568 1.4254.016 0 .1607.0154.3274.0331.2264.024.4933.0523.5331.0523Zm.6817 7.0948c-.184 0-.2956.0329-.3876.0657l-.4007-.6306 1.1167-.9589H4.0379V16h3.015v.7291l-1.1035.9196c.6437.0263 1.2348.5189 1.2348 1.3006 0 .7356-.6043 1.4122-1.6355 1.4122-.9919 0-1.5962-.6437-1.6487-1.3597l.8736-.1708c.0197.4335.3284.7488.775.7488.4533 0 .7226-.289.7226-.6437 0-.4007-.289-.6306-.6962-.6306Z"
}, void 0), "OrderedList24Icon", 24);

var Partial16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M3 8c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1Z"
}, void 0), "Partial16Icon", 16);

var Pause24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M7 7.5C7 6.6716 7.6716 6 8.5 6s1.5.6716 1.5 1.5v9c0 .8284-.6716 1.5-1.5 1.5S7 17.3284 7 16.5v-9Zm7 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v9c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5v-9Z"
}, void 0), "Pause24Icon", 24);

var Pdf24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M16.2428 13.7325c1.1929.0217 2.3757.1218 3.5264.4602.5063.1488.9942.3374 1.4227.6532.8944.6586 1.0656 1.7007.4257 2.6056-.6674.9437-1.7623 1.2685-2.9186.8806-.8312-.2788-1.5517-.7326-2.1907-1.3155-.5933-.5413-1.1691-1.1007-1.7614-1.6438-.0723-.0659-.1987-.1137-.2966-.1083-1.3256.0803-2.6412.2445-3.9384.535-.5054.1128-1.0061.2463-1.5032.3889-.0925.0262-.185.1254-.2335.2147-.6994 1.2947-1.441 2.5641-2.351 3.7298-.443.5675-.9319 1.0944-1.5443 1.4932-1.1764.7651-2.3867.3221-2.774-1.0186-.2252-.7795-.0888-1.4977.3845-2.1617.769-1.08 1.8017-1.8541 2.9726-2.4478.6958-.3527 1.4355-.6225 2.1496-.9419.1126-.0505.2325-.148.2865-.2544.79-1.5528 1.4758-3.1506 2.0827-4.7818.0568-.1525.0412-.2616-.043-.3943C9.1725 8.4221 8.68 7.1237 8.592 5.6964c-.0622-1.0077.0522-1.9848.6463-2.85.5823-.8482 1.5674-1.098 2.3675-.5703.6646.4385 1.0729 1.061 1.1535 1.8604.1062 1.0556-.0806 2.0841-.3378 3.101-.1859.7352-.4129 1.4606-.6317 2.1878-.0412.1372-.0256.2337.0595.351.9905 1.3678 2.1138 2.6255 3.2976 3.8317.0686.0704.194.1137.2957.1209.2654.0145.5328.0036.8001.0036Zm-6.4486.6569c1.1544-.1913 2.285-.379 3.4229-.5675-.7003-.8202-1.4016-1.6421-2.1102-2.4712-.4421 1.0231-.8742 2.0228-1.3127 3.0387Zm.9191-6.6224c.0458-.166.0925-.331.1364-.498.228-.8589.4532-1.7196.4358-2.6155-.0046-.2463-.0714-.508-.1776-.7317-.076-.1597-.2655-.267-.4038-.398-.1208.1471-.2774.2789-.357.4449-.2334.4872-.2637 1.0159-.2344 1.5446.0449.7858.2252 1.541.6006 2.2537Zm-4.1105 9.3272c-.6738.3221-1.2945.665-1.8237 1.1341-.3771.3347-.7168.7137-1.0427 1.0989-.248.2932-.2719.6424-.107.997.075.1624.173.2219.3313.1028.1575-.1182.326-.2255.4678-.359.8862-.8346 1.5225-1.8532 2.155-2.8736.012-.0181.0092-.0424.0193-.1002Zm10.2909-1.818c.6463.6632 1.3229 1.2767 2.2118 1.5916.2032.0721.4303.1037.6463.1046.3076.0018.6537-.2932.6985-.5882.0467-.305-.227-.3844-.4266-.4809-.9841-.4773-2.0552-.5549-3.13-.6271Z"
}, void 0), "Pdf24Icon", 24);

var Pencil24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6.163 14.8842a2.0001 2.0001 0 0 0-.163.7907v4.3263h12v-4.3263a2 2 0 0 0-.1629-.7907L15.3148 9.024H8.6852L6.163 14.8842Zm3.3705-7.8309h4.933l-1.548-3.5966c-.347-.8062-1.49-.8062-1.837 0l-1.548 3.5966Z"
}, void 0), "Pencil24Icon", 24);

var Phone24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M14.3396 9.7547c.6135-.8444.4263-2.0261-.418-2.6396-.8444-.6134-1.0315-1.7952-.4181-2.6395l1.1814-1.626c.7422-1.0215 2.1719-1.248 3.1934-.5058L19.412 3.458a2.0063 2.0063 0 0 1 .7649 2.1189 26.56 26.56 0 0 1-11.542 15.8862 2.0063 2.0063 0 0 1-2.2515-.0726l-1.5338-1.1144c-1.0215-.7421-1.248-2.1718-.5058-3.1933l1.1814-1.6261c.6134-.8443 1.7952-1.0315 2.6395-.418.8444.6134 2.0261.4262 2.6395-.4181l1.7677-2.433 1.7677-2.433Z"
}, void 0), "Phone24Icon", 24);

var Pin24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M10.1608 7.7996c-1.77-.2299-3.6109.2165-5.105 1.339-.2618.1968-.6447.7592-.0377 1.3661l3.531 3.5311-3.641 3.6411-.0777.0872c-.3108.3925-.2849.9643.0777 1.327.3906.3905 1.0237.3905 1.4142 0l3.641-3.6411 3.5377 3.5377.1124.1037c.6257.5296 1.0629.0888 1.2506-.1618 1.117-1.4922 1.561-3.3288 1.3318-5.0947l4.2462-3.3826.0411-.0389c.3905-.3905.3905-1.0237 0-1.4142l-5.487-5.487a1.0075 1.0075 0 0 0-.0844-.0753c-.4321-.344-1.0612-.2725-1.4052.1596l-3.3457 4.203Z"
}, void 0), "Pin24Icon", 24);

var Play24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6 6.3763c0-1.0606 1.2073-1.7214 2.1686-1.187l10.116 5.6237c.9539.5303.9539 1.8437 0 2.374l-10.116 5.6237C7.2073 19.3451 6 18.6843 6 17.6237V6.3763Z"
}, void 0), "Play24Icon", 24);

var Playlist24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h16c.5523 0 1-.4477 1-1s-.4477-1-1-1H4Zm0 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h16c.5523 0 1-.4477 1-1s-.4477-1-1-1H4Zm-1 7c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1Zm12.75-2.567c-.3333-.1924-.75.0481-.75.433v4.3302c0 .3849.4167.6254.75.433l3.75-2.1651c.3333-.1924.3333-.6736 0-.866l-3.75-2.1651Z",
  clipRule: "evenodd"
}, void 0), "Playlist24Icon", 24);

var Plus16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M8 3c-.5523 0-1 .4477-1 1v3H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h3v3c0 .5523.4477 1 1 1s1-.4477 1-1V9h3c.5523 0 1-.4477 1-1s-.4477-1-1-1H9V4c0-.5523-.4477-1-1-1Z"
}, void 0), "Plus16Icon", 16);

var Poll24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.9974 3.0625C13.4494 2.9936 13 3.4478 13 4v6c0 .5523.4477 1 1 1h6c.5523 0 1.0064-.4494.9376-.9974a8.001 8.001 0 0 0-4.8761-6.3936 8.0003 8.0003 0 0 0-2.0641-.5465Zm4.9402 10.935C19.0064 13.4495 18.5523 13 18 13h-6c-.5523 0-1-.4477-1-1V6c0-.5522-.4495-1.0064-.9974-.9375a8.0001 8.0001 0 1 0 8.935 8.935Z",
  clipRule: "evenodd"
}, void 0), "Poll24Icon", 24);

var PopOut16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 2c-.5523 0-1 .4477-1 1v4c0 .5523.4477 1 1 1v4c0 1.1046.8954 2 2 2h7c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2H8c0-.5523-.4477-1-1-1H3Zm2 6h2c.5523 0 1-.4477 1-1V5h4v7H5V8Z",
  clipRule: "evenodd"
}, void 0), "PopOut16Icon", 16);

var PopOut24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 2c-1.1046 0-2 .8954-2 2v6c0 1.1046.8954 2 2 2v7c0 1.6569 1.3431 3 3 3h12c1.6569 0 3-1.3431 3-3V7c0-1.6569-1.3431-3-3-3h-7c0-1.1046-.8954-2-2-2H4Zm2 10h4c1.1046 0 2-.8954 2-2V6h7c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1H7c-.5523 0-1-.4477-1-1v-7Z",
  clipRule: "evenodd"
}, void 0), "PopOut24Icon", 24);

var Post24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.8478 3.8753c-.752-.3562-1.5848.3084-1.4043 1.1207L4.495 9.7272a.5.5 0 0 0 .3153.3608l3.9163 1.4428c.4362.1607.4362.7777 0 .9384L4.8102 13.912a.5.5 0 0 0-.3152.3607l-1.0515 4.7314c-.1805.8123.6523 1.4769 1.4043 1.1207l15.2443-7.221c.7626-.3612.7626-1.4463 0-1.8075L4.8478 3.8753Z",
  clipRule: "evenodd"
}, void 0), "Post24Icon", 24);

var Presenter24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M16 7c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4ZM2 20c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1Zm3-3.5C5 14.567 6.567 13 8.5 13h7c1.933 0 3.5 1.567 3.5 3.5V18H5v-1.5Z"
}, void 0), "Presenter24Icon", 24);

var Privacy24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M13.8675 9.8308v2.2779h-2.7344v-2.278a.4558.4558 0 0 1 .4558-.4557h1.8229c.2517 0 .4557.204.4557.4558Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.6539 2.7305a2.0835 2.0835 0 0 1 1.6923 0l6.2174 2.7633a2.0833 2.0833 0 0 1 1.2372 1.9037v4.18c0 4.9412-3.3002 9.5731-7.8099 10.9338a1.699 1.699 0 0 1-.9817 0c-4.5097-1.3607-7.81-5.9926-7.81-10.9338v-4.18c0-.8233.485-1.5694 1.2373-1.9037l6.2174-2.7633Zm-1.4322 7.1003c0-.7552.6121-1.3674 1.3672-1.3674h1.8229c.7551 0 1.3672.6122 1.3672 1.3674v2.2779h.3252c.5753 0 1.0417.4664 1.0417 1.0416v2.4746c0 .5753-.4664 1.0417-1.0417 1.0417H9.8959c-.5753 0-1.0417-.4664-1.0417-1.0417v-2.4746c0-.5752.4664-1.0416 1.0417-1.0416h.3258v-2.278Z",
    clipRule: "evenodd"
  }, void 0)]
}, void 0), "Privacy24Icon", 24);

var QR24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 6c0-.5523.4477-1 1-1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1H6C4.3431 3 3 4.3431 3 6v3c0 .5523.4477 1 1 1s1-.4477 1-1V6Zm14 12c0 .5523-.4477 1-1 1h-3c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c1.6569 0 3-1.3431 3-3v-3c0-.5523-.4477-1-1-1s-1 .4477-1 1v3Zm0-12c0-.5523-.4477-1-1-1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3c1.6569 0 3 1.3431 3 3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V6ZM6 19c-.5523 0-1-.4477-1-1v-3c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 1.6569 1.3431 3 3 3h3c.5523 0 1-.4477 1-1s-.4477-1-1-1H6ZM7 8c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H8c-.5523 0-1-.4477-1-1V8Zm7-1c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1h2c.5523 0 1-.4477 1-1V8c0-.5523-.4477-1-1-1h-2Zm-1 7c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1v-2Zm-5-1c-.5523 0-1 .4477-1 1v2c0 .5523.4477 1 1 1h2c.5523 0 1-.4477 1-1v-2c0-.5523-.4477-1-1-1H8Z",
  clipRule: "evenodd"
}, void 0), "QR24Icon", 24);

var QuestionMark16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.0406 8.909v.6274h-2.195v-.743c.0324-.4733.1219-.8696.2682-1.1888.1464-.3192.317-.5917.5122-.8173.1951-.2257.4011-.421.6179-.5862a9.792 9.792 0 0 0 .6016-.4953c.1843-.1652.3334-.3468.4472-.545.1138-.198.1653-.4457.1545-.743 0-.5063-.122-.8805-.3659-1.1227-.2439-.2422-.5827-.3633-1.0163-.3633-.2926 0-.5447.0578-.756.1734-.2114.1156-.3849.2697-.5204.4623-.1355.1927-.2357.4183-.3008.677-.065.2587-.0976.5366-.0976.8338H4c.0108-.5944.1111-1.1393.3008-1.6346.1897-.4954.4553-.9247.7968-1.2879.3414-.3633.7534-.6467 1.2357-.8503C6.8157 1.1018 7.355 1 7.9513 1c.7696 0 1.4118.1073 1.9268.322.5149.2146.9295.4816 1.2439.8008.3143.3192.5392.6632.6747 1.032.1355.3687.2033.7127.2033 1.032 0 .5283-.0678.963-.2033 1.3043-.1355.3412-.3035.633-.504.8751-.2006.2422-.4228.4486-.6667.6192a15.3027 15.3027 0 0 0-.691.5118 3.2589 3.2589 0 0 0-.5773.5862c-.168.2202-.2737.4954-.317.8256Zm.1301 4.1624c0 .7021-.5742 1.2714-1.2764 1.2714-.7022 0-1.2764-.5693-1.2764-1.2714 0-.7022.5742-1.2714 1.2764-1.2714.7022 0 1.2764.5692 1.2764 1.2714Z",
  clipRule: "evenodd"
}, void 0), "QuestionMark16Icon", 16);

var QuestionMark24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 12c0 1.4511-.3863 2.8119-1.0618 3.9853l.8119 3.03c.1196.4461-.2887.8544-.7348.7349l-3.0301-.8119C14.8119 19.6137 13.4511 20 12 20c-4.4183 0-8-3.5817-8-8s3.5817-8 8-8 8 3.5817 8 8Zm-7.5368 1.3978c.2079 0 .3763-.1611.3763-.3598v-.1104c.034-.2475.1169-.4538.2486-.6188a2.5008 2.5008 0 0 1 .4525-.4393c.17-.1279.3506-.2557.5418-.3836a2.6104 2.6104 0 0 0 .5226-.4641c.1573-.1815.289-.4001.3952-.6558.1062-.2558.1594-.5817.1594-.9776 0-.2393-.0532-.4971-.1594-.7735-.1062-.2764-.2825-.5342-.529-.7734-.2464-.2393-.5715-.4393-.9752-.6002C13.0924 7.0804 12.5888 7 11.9855 7c-.4674 0-.8902.0763-1.2684.229-.3782.1526-.7011.365-.9688.6372-.2677.2723-.476.594-.6246.9653-.1071.2673-.1778.5538-.2122.8595-.0225.2001.149.3656.3596.3656h1.3652a.1269.1269 0 0 0 .1279-.1199 2.3823 2.3823 0 0 1 .074-.505c.051-.194.1296-.363.2358-.5074.1062-.1444.2422-.2599.4079-.3465.1658-.0866.3633-.13.5928-.13.3399 0 .6055.0908.7967.2723.1912.1815.2868.462.2868.8415.0085.2227-.0319.4084-.1211.5569-.0892.1485-.2061.2846-.3505.4083a7.6142 7.6142 0 0 1-.4717.3713c-.17.1237-.3314.2702-.4844.4393-.153.1691-.2868.3733-.4015.6125-.1148.2393-.1849.5363-.2104.891v.1971c0 .1987.1685.3598.3763.3598h.9683Zm-.5224 3.6023c.5505 0 1.0007-.4266 1.0007-.9528 0-.5263-.4502-.9529-1.0007-.9529-.5504 0-1.0006.4266-1.0006.9529 0 .5262.4502.9528 1.0006.9528Z",
  clipRule: "evenodd"
}, void 0), "QuestionMark24Icon", 24);

var Quiz24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12.7481 2.1918 6.3683 3.4836c.258.1411.3555.47.2179.7346a.5367.5367 0 0 1-.1947.21l-6.3221 3.8905a1.554 1.554 0 0 1-1.6343 0l-6.322-3.8904c-.2508-.1543-.332-.4878-.1816-.745a.5354.5354 0 0 1 .2048-.1997l6.3689-3.4837a1.5533 1.5533 0 0 1 1.4948 0ZM21 8.7146v7.8922c0 .5722-.2927 1.1024-.7711 1.3968l-6.3682 3.9188c-.2507.1543-.5759.0709-.7263-.1863a.553.553 0 0 1-.0754-.2793v-7.8922c0-.5722.2927-1.1024.771-1.3968l6.3682-3.9188c.2507-.1543.5759-.0709.7263.1863A.5533.5533 0 0 1 21 8.7146Zm-10.8298 3.4532L3.802 8.249a.5194.5194 0 0 0-.2724-.0774c-.2923 0-.5294.2431-.5294.543v7.8922c0 .5721.2927 1.1024.7711 1.3967l6.3682 3.9188a.5185.5185 0 0 0 .2723.0774c.2924 0 .5294-.2431.5294-.5429v-7.8922c0-.5722-.2927-1.1024-.771-1.3968Z",
  clipRule: "evenodd"
}, void 0), "Quiz24Icon", 24);

var Record24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8 8-3.5817 8-8-3.5817-8-8-8Zm-6 8c0-3.3137 2.6863-6 6-6s6 2.6863 6 6-2.6863 6-6 6-6-2.6863-6-6Zm6-5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5Z",
  clipRule: "evenodd"
}, void 0), "Record24Icon", 24);

var RecordOn24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8Zm8-6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6 6-2.6863 6-6-2.6863-6-6-6Z",
    clipRule: "evenodd"
  }, void 0), jsx("rect", {
    width: "10",
    height: "10",
    x: "7",
    y: "7",
    fill: "currentColor",
    rx: "5"
  }, void 0)]
}, void 0), "RecordOn24Icon", 24);

var Recyclebin24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M14.6595 4.0122 14.4778 4c-.6594.0005-1.2334.4895-1.3241 1.1628-.0988.7346.4151 1.4104 1.1478 1.5095 2.8584.3866 5.0209 2.8573 5.0209 5.7956 0 3.2311-2.5987 5.8479-5.8014 5.8479s-5.8014-2.6168-5.8014-5.8479c0-.7605.144-1.4974.416-2.1799l.747 2.0509.0737.167c.3062.5857.9984.871 1.6271.6422.6857-.2496 1.0361-1.0165.7826-1.7131L9.53 6.3904l-.0737-.167c-.3063-.5856-.9985-.871-1.627-.6422L2.8624 7.389l-.1643.0728c-.5757.304-.8508 1.0018-.6184 1.6402l.0736.167c.3063.5857.9985.8711 1.6271.6423L5.6782 9.22c-.4156 1.0156-.6362 2.1152-.6362 3.2479C5.042 17.1787 8.8368 21 13.521 21 18.2052 21 22 17.1787 22 12.4679c0-4.2842-3.1558-7.8897-7.3405-8.4557Z"
}, void 0), "Recyclebin24Icon", 24);

var Redo16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M8.688 3.3069 8.5862 3.3a.7501.7501 0 0 0-.0987 1.4934c1.6012.216 2.8127 1.5968 2.8127 3.2387 0 1.8057-1.4558 3.268-3.25 3.268s-3.25-1.4623-3.25-3.268c0-.5088.1156-.9989.3316-1.4403l.5588 1.534.0412.0932a.7502.7502 0 0 0 1.3683-.6063l-1.026-2.819-.0413-.0934a.7501.7501 0 0 0-.92-.355L2.2937 5.3715l-.0933.0413a.7501.7501 0 0 0-.355.92l.0413.0933a.7501.7501 0 0 0 .92.355l.7405-.2697a4.784 4.784 0 0 0-.247 1.5208c0 2.6326 2.1259 4.768 4.75 4.768s4.75-2.1354 4.75-4.768c0-2.394-1.7679-4.409-4.1122-4.7252Z"
}, void 0), "Redo16Icon", 16);

var Redo24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m17.8276 14.4666 2.0468-3.6925c.2678-.4831.0933-1.0917-.3898-1.3595-.483-.2677-1.0917-.0932-1.3594.3899l-.7686 1.3866C16.2744 8.7236 13.8099 7 10.9429 7c-3.866 0-7 3.134-7 7 0 .5523.4478 1 1 1 .5523 0 1-.4477 1-1 0-2.7614 2.2386-5 5-5 2.0865 0 3.8744 1.2779 4.6238 3.0938l-1.8496-1.0253c-.4831-.2678-1.0917-.0933-1.3595.3898-.2677.483-.0932 1.0917.3898 1.3594l3.6934 2.0473a.9966.9966 0 0 0 .5934.1309.995.995 0 0 0 .4295-.142 1.0052 1.0052 0 0 0 .3639-.3873Z"
}, void 0), "Redo24Icon", 24);

var Refresh24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.2205 10.2493C5.9975 7.2299 8.7396 5 12 5c2.7135 0 5.068 1.5446 6.2295 3.8035l-2.0903-.2938c-.547-.0768-1.0526.3042-1.1295.8511-.0768.547.3042 1.0526.8512 1.1295l3.7699.5297a1 1 0 0 0 1.0663-.6156l1.4262-3.5298c.2069-.512-.0405-1.0949-.5525-1.3018-.5121-.2069-1.0949.0405-1.3018.5526l-.5219 1.2917C18.1797 4.773 15.2977 3 12 3 7.805 3 4.2826 5.8692 3.2836 9.7507c-.1377.5349.1843 1.0801.7192 1.2177.5348.1377 1.08-.1843 1.2177-.7191ZM12.002 19c3.2604 0 6.0024-2.2299 6.7796-5.2493.1376-.5348.6828-.8568 1.2177-.7191.5348.1376.8568.6828.7191 1.2177C19.7194 18.1308 16.1971 21 12.002 21c-3.2977 0-6.1797-1.773-7.747-4.4171l-.522 1.2917c-.2069.5121-.7897.7595-1.3018.5526-.512-.2069-.7594-.7898-.5525-1.3018l1.4262-3.5298a1 1 0 0 1 1.0663-.6156l3.77.5297c.5469.0769.928.5825.851 1.1295-.0768.5469-.5824.9279-1.1293.8511l-2.0904-.2938C6.934 17.4554 9.2885 19 12.002 19Z"
}, void 0), "Refresh24Icon", 24);

var Remove24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9ZM8.4645 8.4645c.3626-.3627.9344-.3886 1.327-.0777l.0872.0777L12 10.5858l2.1213-2.1213.0942-.0832c.3923-.305.9595-.2773 1.32.0832.3906.3905.3906 1.0236 0 1.4142L13.4142 12l2.1213 2.1213c.3906.3905.3906 1.0237 0 1.4142-.3626.3627-.9344.3886-1.327.0777l-.0872-.0777L12 13.4142l-2.1213 2.1213-.0942.0832c-.3923.305-.9596.2773-1.32-.0832-.3906-.3905-.3906-1.0237 0-1.4142L10.5858 12 8.4645 9.8787c-.3906-.3905-.3906-1.0237 0-1.4142Z",
  clipRule: "evenodd"
}, void 0), "Remove24Icon", 24);

var Resolved24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9Zm4.6402 5.2318c-.4243-.3536-1.0549-.2963-1.4084.128L10.932 13.517l-1.2249-1.2241-.0942-.0832c-.3923-.305-.9595-.2773-1.32.0832-.3905.3905-.3905 1.0237 0 1.4142l2 2 .093.0823c.4188.3269 1.0328.2703 1.3823-.1492l5-6 .0743-.1014c.2683-.4183.1893-.9807-.2023-1.307Z",
  clipRule: "evenodd"
}, void 0), "Resolved24Icon", 24);

var RightHand24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v8.5a.5.5 0 1 1-1 0V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v9.2l-1.077-2.5846c-.2123-.5098-.7978-.7509-1.3076-.5385-.5098.2125-.7509.7979-.5385 1.3077C6.6763 16.2232 7.832 22 13 22c3.3137 0 6-2.6863 6-6V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v4.5a.5.5 0 1 1-1 0V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v5.75a.5.5 0 1 1-1 0V3Z"
}, void 0), "RightHand24Icon", 24);

var Score24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9Zm.9557-13.3765.6639 1.4244c.1824.3913.5405.662.9544.7215l1.51.2169c.5804.0834.986.6408.9059 1.2451-.0326.2462-.144.4738-.3162.6459l-1.0972 1.0965c-.3017.3016-.4387.7402-.365 1.1688l.2677 1.5573c.1033.6008-.2808 1.175-.8579 1.2825a1.0246 1.0246 0 0 1-.6872-.1131l-1.3448-.748a1.2071 1.2071 0 0 0-1.1788 0l-1.3451.7481c-.517.2876-1.1601.0843-1.4364-.4539a1.1451 1.1451 0 0 1-.1086-.7156l.268-1.5572c.0737-.4287-.0633-.8674-.365-1.1689l-1.0972-1.0965c-.4227-.4225-.4364-1.1217-.0306-1.5618.1653-.1792.3838-.2952.6203-.3292l1.51-.217c.414-.0594.772-.33.9544-.7214l.6638-1.4245c.2562-.5495.8917-.7789 1.4196-.5122.2146.1084.3879.2888.492.5122Z",
  clipRule: "evenodd"
}, void 0), "Score24Icon", 24);

var Search24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 4c-3.866 0-7 3.134-7 7s3.134 7 7 7c1.5759 0 3.0302-.5208 4.2001-1.3996a.9986.9986 0 0 0 .0928.1067l3 3c.3905.3905 1.0237.3905 1.4142 0 .3905-.3905.3905-1.0237 0-1.4142l-3-3a.9986.9986 0 0 0-.1067-.0928C17.4792 14.0302 18 12.5759 18 11c0-3.866-3.134-7-7-7Zm-5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5Z",
  clipRule: "evenodd"
}, void 0), "Search24Icon", 24);

var SelfServedLive24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    stroke: "currentColor",
    "stroke-width": "2",
    d: "M16 3H7.9342c-.8865 0-1.6503-.0001-2.262.0821-.6555.0882-1.2839.287-1.7935.7966-.5097.5096-.7084 1.138-.7966 1.7935C3 6.284 3 7.0477 3 7.9342v4.1316c0 .8865-.0001 1.6503.0821 2.262.0882.6555.287 1.2839.7966 1.7935.5096.5097 1.138.7084 1.7935.7966.6117.0822 1.3755.0822 2.262.0821h8.1316c.8865.0001 1.6503.0001 2.262-.0821.6555-.0882 1.2839-.2869 1.7935-.7966.5097-.5096.7084-1.138.7966-1.7935.0822-.6117.0822-1.3755.0821-2.262V7.9342c.0001-.8865.0001-1.6503-.0821-2.262-.0882-.6555-.2869-1.2839-.7966-1.7935-.5096-.5097-1.138-.7084-1.7935-.7966C17.7161 3 16.9523 3 16.0658 3H16Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5338 8.9733c-.2896-.3818-.2227-.9325.1495-1.23 1.5388-1.2301 3.4392-1.8864 5.3888-1.861 1.9496.0254 3.8323.731 5.3385 2.0006.3643.3072.4169.8594.1174 1.2336-.2994.3742-.8376.4285-1.2019.1214-1.2067-1.0172-2.715-1.5824-4.2768-1.6028-1.5619-.0203-3.0844.5055-4.3171 1.4909-.3722.2975-.9088.2292-1.1984-.1527Zm2.3832 2.4931c-.2548-.4071-.1397-.9494.2571-1.2113.8501-.5608 1.8419-.8529 2.852-.8397 1.0101.0131 1.994.3309 2.8291.9137.3899.2721.4909.8172.2255 1.2176-.2654.4003-.7965.5043-1.1864.2322-.5583-.3895-1.2159-.6019-1.891-.6107-.6752-.0088-1.3381.1864-1.9063.5613-.3968.2618-.9251.144-1.18-.2631Zm2.4853 2.6481c-.3354-.3534-.3295-.9178.0133-1.2606l.0063-.0062c.3428-.3428.8926-.3343 1.228.0191.3355.3534.3295.9178-.0133 1.2606l-.0062.0062c-.3428.3428-.8927.3343-1.2281-.0191ZM8 21c0 .5523.5625 1 .9442 1h7.1116c.3817 0 .9442-.4477.9442-1s-.5625-1-.9442-1H8.9442C8.5625 20 8 20.4477 8 21Z",
    clipRule: "evenodd"
  }, void 0)]
}, void 0), "SelfServedLive24Icon", 24);

var Settings24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.9348 13.1582a1.2225 1.2225 0 0 1-1.2084 1.0833h-.1667a1.3442 1.3442 0 0 0-.8916 2.3442 1.2377 1.2377 0 0 1 .1333 1.6759 9.8697 9.8697 0 0 1-1.625 1.5992 1.2262 1.2262 0 0 1-.7501.2608 1.2438 1.2438 0 0 1-.9083-.3975 1.4324 1.4324 0 0 0-1.0417-.4341 1.255 1.255 0 0 0-.4667.0875 1.3616 1.3616 0 0 0-.8333 1.3 1.23 1.23 0 0 1-1.0917 1.2617 9.9642 9.9642 0 0 1-2.25-.0059c-.6443-.0753-1.1167-.6419-1.075-1.2892a1.3633 1.3633 0 0 0-.825-1.3208 1.2489 1.2489 0 0 0-.475-.0908 1.438 1.438 0 0 0-1.0418.4333c-.4377.4822-1.1751.5406-1.6833.1333a9.8782 9.8782 0 0 1-1.575-1.6025c-.4-.5014-.3416-1.2273.1333-1.6584a1.3658 1.3658 0 0 0 .3417-1.5075 1.3333 1.3333 0 0 0-1.2084-.8333h-.05a1.31 1.31 0 0 1-1.3083-1.0876 9.4376 9.4376 0 0 1 0-2.2742 1.21 1.21 0 0 1 1.25-1.0833 1.4425 1.4425 0 0 0 1.3583-.8217 1.3534 1.3534 0 0 0-.3416-1.5192 1.2367 1.2367 0 0 1-.1334-1.675 10.0221 10.0221 0 0 1 1.6167-1.6 1.255 1.255 0 0 1 .7584-.2609 1.24 1.24 0 0 1 .9083.4 1.44 1.44 0 0 0 1.0417.4309 1.2734 1.2734 0 0 0 .4667-.0834 1.3633 1.3633 0 0 0 .8333-1.3025 1.2292 1.2292 0 0 1 1.0917-1.26 10.0081 10.0081 0 0 1 2.25.0058c.6437.0758 1.1158.6416 1.0751 1.2884a1.3532 1.3532 0 0 0 .825 1.3225c.1511.0602.3123.0907.475.09a1.441 1.441 0 0 0 1.0417-.4325c.435-.4804 1.1687-.5396 1.675-.135a9.7917 9.7917 0 0 1 1.5834 1.6009 1.221 1.221 0 0 1-.1334 1.6666 1.3434 1.3434 0 0 0 .925 2.3392c.64-.0054 1.19.4529 1.3001 1.0834a9.9015 9.9015 0 0 1 0 2.2684ZM12.016 16A4 4 0 1 1 16 12c.0033 2.2043-1.7797 3.9944-3.984 4Z",
  clipRule: "evenodd"
}, void 0), "Settings24Icon", 24);

var Shape24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 8c0-1.1046-.8954-2-2-2H8c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2h8c1.1046 0 2-.8954 2-2V8ZM6 4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2H6Z",
  clipRule: "evenodd"
}, void 0), "Shape24Icon", 24);

var Shapefull24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 4.5c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2v-12c0-1.1046-.8954-2-2-2H6Z",
  clipRule: "evenodd"
}, void 0), "Shapefull24Icon", 24);

var Share24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M20.5699 10.3763a.5.5 0 0 0 0-.7526l-6.7407-5.8981C13.5059 3.4427 13 3.6723 13 4.1019v2.4225c0 .2664-.2056.4888-.4696.5249-1.8597.2541-8.6464 1.76-9.452 10.2442-.0473.4968.5998.708.9072.3149 3.5243-4.5057 7.3594-4.7153 8.6016-4.6493.2413.0128.4128.2165.4128.4582v2.4808c0 .4296.5059.6592.8292.3763l6.7407-5.8981Z"
}, void 0), "Share24Icon", 24);

var ShareScreen24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 3C4.3431 3 3 4.3431 3 6v12c0 1.6569 1.3431 3 3 3h12c1.6569 0 3-1.3431 3-3V6c0-1.6569-1.3431-3-3-3H6Zm6.7071 4.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L11 10.4142V16c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5858l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0 .3905-.3905.3905-1.0237 0-1.4142l-4-4Z",
  clipRule: "evenodd"
}, void 0), "ShareScreen24Icon", 24);

var ShareScreenClose24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6c0-1.6569 1.3431-3 3-3h12c1.6569 0 3 1.3431 3 3v12c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3V6Zm13 8.5857L13.4142 12 16 9.4142c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3905-1.0237-.3905-1.4143 0L12 10.5858 9.4142 8C9.0237 7.6095 8.3905 7.6095 8 8c-.3905.3905-.3905 1.0237 0 1.4142L10.5858 12l-2.5 2.5c-.3905.3905-.3905 1.0236 0 1.4142.3905.3905 1.0237.3905 1.4142 0l2.5-2.5L14.5858 16c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4143Z",
  clipRule: "evenodd"
}, void 0), "ShareScreenClose24Icon", 24);

var Shuffle24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M19.2682 3.3598c-.3535-.4242-.9841-.4816-1.4084-.128-.4243.3536-.4816.9841-.128 1.4084L18.865 6H16.5a1 1 0 0 0-.7071.293L5.0858 17H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.5a.9997.9997 0 0 0 .7071-.2929l10.7071-10.707h1.9508l-1.1332 1.3597c-.3536.4243-.2963 1.0549.128 1.4084.4243.3536 1.0549.2963 1.4084-.128l2.5-3a.9998.9998 0 0 0 0-1.2804l-2.5-3Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "m6.2071 6.2929 4.0858 4.0858-1.4142 1.4142L5.0857 8H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.5a1 1 0 0 1 .7071.2929Zm5.5 8.3284 1.4142-1.4142L16.9142 17h1.9508l-1.1332-1.3598c-.3536-.4243-.2963-1.0549.128-1.4084.4243-.3536 1.0549-.2963 1.4084.128l2.5 3a.9999.9999 0 0 1 0 1.2804l-2.5 3c-.3535.4243-.9841.4816-1.4084.128-.4243-.3535-.4816-.9841-.128-1.4084L18.865 19H16.5a1.0001 1.0001 0 0 1-.7071-.2929l-4.0858-4.0858Z"
  }, void 0)]
}, void 0), "Shuffle24Icon", 24);

var Sidebar24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6Zm2 0h12v12H6V9.9999h12v-2H6V6Z",
  clipRule: "evenodd"
}, void 0), "Sidebar24Icon", 24);

var SidebarBottom24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 18c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12Zm-2 0H6V6h12v8.0001H6v2h12V18Z",
  clipRule: "evenodd"
}, void 0), "SidebarBottom24Icon", 24);

var SidebarLeft24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 20c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6Zm0-2V6h12v12H9.9999V6h-2v12H6Z",
  clipRule: "evenodd"
}, void 0), "SidebarLeft24Icon", 24);

var SidebarRight24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 4c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h12Zm0 2v12H6V6h8.0001v12h2V6H18Z",
  clipRule: "evenodd"
}, void 0), "SidebarRight24Icon", 24);

var SideBySide16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14 0c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H2c-1.1046 0-2-.8954-2-2V2C0 .8954.8954 0 2 0h12ZM9 2h5v12H9V2ZM7 14H2V2h5v12Z",
  clipRule: "evenodd"
}, void 0), "SideBySide16Icon", 16);

var SideBySide24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 4c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h12Zm-5 2h5v12h-5V6Zm-2 12H6V6h5v12Z",
  clipRule: "evenodd"
}, void 0), "SideBySide24Icon", 24);

var Simulive24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "m10.4749 15.855 4.929-3.0466a.9589.9589 0 0 0 .3066-.3032c.2822-.4465.1449-1.0346-.3066-1.3137l-4.929-3.0466A.9718.9718 0 0 0 9.9639 8C9.4317 8 9 8.4268 9 8.9533v6.0932a.946.946 0 0 0 .1465.5053c.2822.4465.8769.5822 1.3284.3032Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10Zm-10 8c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8Z",
    clipRule: "evenodd"
  }, void 0)]
}, void 0), "Simulive24Icon", 24);

var Slack24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M7.3616 14.1108c0 .9251-.7557 1.6808-1.6808 1.6808S4 15.0359 4 14.1108 4.7557 12.43 5.6808 12.43h1.6808v1.6808Zm.8469 0c0-.9251.7557-1.6808 1.6807-1.6808.9251 0 1.6808.7557 1.6808 1.6808v4.2084c0 .9251-.7557 1.6808-1.6807 1.6808-.9251 0-1.6808-.7557-1.6808-1.6808v-4.2084Zm1.6808-6.7492c-.9251 0-1.6808-.7557-1.6808-1.6808S8.9642 4 9.8892 4c.9251 0 1.6808.7557 1.6808 1.6808v1.6808H9.8893Zm0 .8468c.925 0 1.6807.7557 1.6807 1.6808S10.8143 11.57 9.8893 11.57H5.6808C4.7557 11.57 4 10.8143 4 9.8892c0-.925.7557-1.6808 1.6808-1.6808h4.2085Zm6.7491 1.6808c0-.925.7557-1.6808 1.6808-1.6808S20 8.9641 20 9.8892s-.7557 1.6808-1.6808 1.6808h-1.6808V9.8892Zm-.8469.0001c0 .925-.7557 1.6807-1.6808 1.6807-.925 0-1.6807-.7557-1.6807-1.6807V5.6808C12.43 4.7557 13.1857 4 14.1107 4c.9251 0 1.6808.7557 1.6808 1.6808v4.2085Zm-1.6808 6.7491c.9251 0 1.6808.7557 1.6808 1.6808S15.0358 20 14.1107 20c-.925 0-1.6807-.7557-1.6807-1.6808v-1.6808h1.6807Zm0-.8468c-.925 0-1.6807-.7557-1.6807-1.6808s.7557-1.6808 1.6807-1.6808h4.2085c.9251 0 1.6808.7557 1.6808 1.6808s-.7557 1.6808-1.6808 1.6808h-4.2085Z"
}, void 0), "Slack24Icon", 24);

var Slide24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 4C4.3431 4 3 5.3431 3 7v10c0 1.6569 1.3431 3 3 3h12c1.6569 0 3-1.3431 3-3V7c0-1.6569-1.3431-3-3-3H6Zm12 4H6v8h12V8Z",
  clipRule: "evenodd"
}, void 0), "Slide24Icon", 24);

var Sound24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.5 4.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v15c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5v-15ZM4.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v6c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5V9ZM18 7.5c-.8284 0-1.5.6716-1.5 1.5v6c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5V9c0-.8284-.6716-1.5-1.5-1.5Z",
  clipRule: "evenodd"
}, void 0), "Sound24Icon", 24);

var Speaker24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M20.0193 11.9635a10.0198 10.0198 0 0 0-1.5509-5.3183l-.0221-.0348a1.1461 1.1461 0 0 1-.0781-.1443c-.1984-.4393-.1031-.9713.2832-1.2754.4298-.3382 1.0562-.266 1.3579.1901a11.3912 11.3912 0 0 1 .2014.3151 11.9998 11.9998 0 0 1-.1535 12.8503c-.2983.4583-.9242.5351-1.3565.1999-.3885-.3012-.4876-.8325-.2925-1.2733.022-.0496.0477-.098.0771-.1449l.0218-.0349a10.0187 10.0187 0 0 0 1.5122-5.3295Zm-8.3912-6.2693C12.6209 4.985 14 5.6947 14 6.9148v10.1704c0 1.2201-1.3791 1.9297-2.3719 1.2206l-4.237-3.0264A1.5001 1.5001 0 0 0 6.5194 15H3.5c-.8284 0-1.5-.6716-1.5-1.5v-3C2 9.6715 2.6716 9 3.5 9h3.0193a1.5 1.5 0 0 0 .8719-.2794l4.2369-3.0264Z"
}, void 0), "Speaker24Icon", 24);

var SpeakerMuted24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14 6.9147c0-1.22-1.3791-1.9297-2.3719-1.2206l-4.237 3.0265A1.5 1.5 0 0 1 6.5194 9H3.5C2.6716 9 2 9.6715 2 10.5v3c0 .8284.6716 1.5 1.5 1.5h3.0193c.3126 0 .6175.0977.8719.2794l4.2369 3.0264c.9928.7091 2.3719-.0006 2.3719-1.2206V6.9147Zm6.4142 2.2569c.3905-.3906 1.0237-.3906 1.4142 0 .3906.3905.3906 1.0237 0 1.4142L20.4142 12l1.4142 1.4142c.3906.3905.3906 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L19 13.4142l-1.4142 1.4142c-.3905.3905-1.0237.3905-1.4142 0-.3906-.3905-.3906-1.0237 0-1.4142L17.5858 12l-1.4142-1.4142c-.3906-.3905-.3906-1.0237 0-1.4142.3905-.3906 1.0237-.3906 1.4142 0L19 10.5858l1.4142-1.4142Z",
  clipRule: "evenodd"
}, void 0), "SpeakerMuted24Icon", 24);

var SpeakerView24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6Zm2 0h12v12H6V9.9999h12v-2H6V6Z",
  clipRule: "evenodd"
}, void 0), "SpeakerView24Icon", 24);

var Speed24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 8.5714c.6213 0 1.125.5178 1.125 1.1395l.001 3.6274c1.3103.471 2.249 1.7407 2.249 3.2331C15.375 18.465 13.864 20 12 20s-3.375-1.535-3.375-3.4286c0-1.4928.9392-2.7628 2.2501-3.2335l-.0001-3.627c0-.5844.4306-1.066.993-1.1318L12 8.5714ZM12 4c4.9354 0 9 3.5393 9 8 0 .6312-.5037 1.1429-1.125 1.1429S18.75 12.6312 18.75 12c0-3.1135-2.9869-5.7143-6.75-5.7143S5.25 8.8865 5.25 12c0 .6312-.5037 1.1429-1.125 1.1429S3 12.6312 3 12c0-4.4607 4.0646-8 9-8Z",
  clipRule: "evenodd"
}, void 0), "Speed24Icon", 24);

var Split24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m17.61 18.84-5.58-5.58-2.133 2.133c.109.195.1867.4018.2332.6203.0465.2185.0698.4407.0698.6667 0 .7838-.279 1.4547-.837 2.0128-.558.5582-1.2287.8372-2.0122.8372-.7836 0-1.4546-.279-2.013-.8369-.5586-.558-.8378-1.2287-.8378-2.0123 0-.7835.279-1.4545.8372-2.013.5581-.5585 1.229-.8378 2.0128-.8378.226 0 .4482.0233.6667.0698a2.202 2.202 0 0 1 .6203.2333L10.77 12 8.637 9.867a2.2042 2.2042 0 0 1-.6203.2332 3.1943 3.1943 0 0 1-.6667.0698c-.7838 0-1.4547-.279-2.0128-.837C4.779 8.775 4.5 8.1043 4.5 7.3208c0-.7835.279-1.4545.837-2.013.558-.5586 1.2287-.8378 2.0122-.8378.7835 0 1.4545.279 2.013.8372.5585.5581.8378 1.229.8378 2.0128 0 .226-.0233.4483-.0698.6667a2.2037 2.2037 0 0 1-.2332.6203L19.5 18.21v.63h-1.89Zm-3.42-7.74-1.26-1.26 4.68-4.68h1.89v.63l-5.31 5.31ZM7.35 9c.462 0 .8575-.1645 1.1865-.4935.329-.329.4935-.7245.4935-1.1865 0-.462-.1645-.8575-.4935-1.1865-.329-.329-.7245-.4935-1.1865-.4935-.462 0-.8575.1645-1.1865.4935-.329.329-.4935.7245-.4935 1.1865 0 .462.1645.8575.4935 1.1865C6.4925 8.8355 6.888 9 7.35 9Zm4.68 3.195c.052 0 .0975-.0195.1365-.0585.039-.039.0585-.0845.0585-.1365 0-.052-.0195-.0975-.0585-.1365-.039-.039-.0845-.0585-.1365-.0585-.052 0-.0975.0195-.1365.0585-.039.039-.0585.0845-.0585.1365 0 .052.0195.0975.0585.1365.039.039.0845.0585.1365.0585ZM7.35 18.36c.462 0 .8575-.1645 1.1865-.4935.329-.329.4935-.7245.4935-1.1865 0-.462-.1645-.8575-.4935-1.1865C8.2075 15.1645 7.812 15 7.35 15c-.462 0-.8575.1645-1.1865.4935-.329.329-.4935.7245-.4935 1.1865 0 .462.1645.8575.4935 1.1865.329.329.7245.4935 1.1865.4935Z"
}, void 0), "Split24Icon", 24);

var StackOverflow24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M14.7735 3 19.5 9.4403l-1.2682.9644-4.7266-6.4402L14.7735 3Zm-3.9337 3.7973 6.0817 5.1547 1.0095-1.2375-6.0817-5.1547-1.0095 1.2374ZM8.85 10.3733l7.179 3.3945.6652-1.458-7.1827-3.4035-.6615 1.467Zm6.7365 5.4029-7.7535-1.647.3248-1.5787 7.7535 1.659-.3248 1.5667Zm-.0008.402H7.6613v1.5953h7.9244v-1.5953Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M4.5 21v-6.4282h1.5847v4.821h11.0746v-4.821h1.5847V21H4.5Z"
  }, void 0)]
}, void 0), "StackOverflow24Icon", 24);

var Stage24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.1274 4.4616c0-.8761 1.0467-1.3287 1.685-.7286L19.095 16.2204c.4318.3336.6717.703.6717 1.0916 0 1.4845-3.5009 2.688-7.8196 2.688-4.1602 0-7.5617-1.1168-7.8056-2.5259l-.014.0009V4.4616ZM17.1512 16.357c.6474.2225 1.0997.4649 1.3702.6848.2771.2252.2771.3153 0 .5405-.2705.2198-.7228.4622-1.3702.6847-1.2851.4418-3.1251.733-5.2042.733s-3.919-.2912-5.2042-.733c-.6474-.2225-1.0997-.4649-1.3702-.6847-.277-.2252-.277-.3153 0-.5405.2705-.2199.7228-.4623 1.3702-.6848 1.2851-.4418 3.1251-.733 5.2042-.733s3.9191.2912 5.2042.733Z",
  clipRule: "evenodd"
}, void 0), "Stage24Icon", 24);

var StarFull24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M12.8884 3.4018a1 1 0 0 0-1.7778 0L8.6276 8.219l-5.3487.873a1 1 0 0 0-.5493 1.6907l3.814 3.8501-.8226 5.3567a1 1 0 0 0 1.4382 1.0449l4.8403-2.4377 4.8403 2.4377a1 1 0 0 0 1.4382-1.0449l-.8226-5.3567 3.814-3.8501a.9999.9999 0 0 0-.5493-1.6907l-5.3487-.873-2.483-4.817Z"
}, void 0), "StarFull24Icon", 24);

var StarHollow24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.9995 2.86a1 1 0 0 1 .8889.5418l2.483 4.8171 5.3487.873a1 1 0 0 1 .5493 1.6907l-3.814 3.8501.8226 5.3567a1.0002 1.0002 0 0 1-1.4382 1.0449l-4.8403-2.4377-4.8403 2.4377a1 1 0 0 1-1.4382-1.0449l.8226-5.3567-3.814-3.8501a1 1 0 0 1 .5493-1.6907l5.3487-.873 2.483-4.817a1.0002 1.0002 0 0 1 .8889-.542Zm0 3.1826-1.8249 3.5403a1.0001 1.0001 0 0 1-.7278.5288l-3.931.6416 2.8031 2.8296c.223.2251.326.5425.278.8556l-.6046 3.9369 3.5574-1.7915a1 1 0 0 1 .8996 0l3.5574 1.7915-.6046-3.9369a1.0002 1.0002 0 0 1 .278-.8556l2.8032-2.8296-3.9311-.6416a1.0002 1.0002 0 0 1-.7278-.5288l-1.8249-3.5404Z",
  clipRule: "evenodd"
}, void 0), "StarHollow24Icon", 24);

var Stop24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M6 8c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2v8c0 1.1046-.8954 2-2 2H8c-1.1046 0-2-.8954-2-2V8Z"
}, void 0), "Stop24Icon", 24);

var Subscribe24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M18 3c0-.5523.4477-1 1-1s1 .4477 1 1v1h1c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1V6h-1c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V3Zm-7.9812 19c1.8409.0054 3.3287-1.2381 3.3231-2.9821H6.6815c.1067 1.6579 1.562 2.9769 3.3373 2.9821Zm4.9897-12.6961C14.6645 6.8478 12.5074 5.0077 9.9631 5c-2.5443-.0077-4.6898 1.8194-5.0183 4.2735l-.8156 6.0927-.8-.0025c-.7363-.0022-1.3315.5771-1.3292 1.294.0023.7168.601 1.2998 1.3374 1.302L16.6708 18c.7363.0022 1.3315-.5771 1.3292-1.294-.0023-.7168-.6011-1.2997-1.3374-1.302l-.8-.0024-.8541-6.0977Z"
}, void 0), "Subscribe24Icon", 24);

var Subscribed24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.9585 2c2.8623.0095 5.289 2.2804 5.6761 5.3115l.9608 6.4818.9.003c.8284.0027 1.502.7221 1.5046 1.6068.0025.8847-.667 1.5996-1.4954 1.5969l-15-.0497c-.8284-.0028-1.502-.7222-1.5046-1.6069-.0025-.8847.667-1.5996 1.4954-1.5969l.9.003.9175-6.4755C6.6825 4.2453 9.0962 1.9905 11.9585 2Zm3.3834 16.8519c.0056 1.744-1.4822 3.1535-3.3231 3.1481-1.7752-.0053-3.2306-1.3242-3.3373-2.9822l-.0063-.1855 6.6667.0196ZM13.596 8.2753c.2807-.3246.7814-.3684 1.1183-.098.3109.2497.3737.68.1607 1l-.0591.0775-2.8239 3.4699c-.2775.3209-.765.3643-1.0976.1142l-.0738-.063-1.588-1.53c-.3101-.2988-.3101-.7832 0-1.0819.2862-.2758.7366-.297 1.0481-.0637l.0748.0637.9726.9364 2.2679-2.8251Z",
  clipRule: "evenodd"
}, void 0), "Subscribed24Icon", 24);

var Switch24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m17.6744 9.2793 4.0819 4.0839.0719.0905.0588.0955.0463.0997.0351.1067.014.0616.015.1118L22 14l-.0103.1405-.0073.0423-.0289.1121-.0304.081-.0361.0749-.0589.0955-.0518.0674-.0556.0607-4.0463 4.0463a.9539.9539 0 0 1-1.4281-1.259l.0793-.0898 2.4183-2.4183-5.7902.0001c-.4862 0-.8874-.3638-.9463-.8341L12 14c0-.4891.3682-.8922.8425-.9473l.1112-.0064 5.7889-.0012-2.417-2.417c-.3458-.3458-.3705-.8912-.0741-1.2656l.0741-.0832a.9538.9538 0 0 1 1.3488 0Zm-11.3488-4a.9537.9537 0 0 1 1.3488 0l.074.0832c.2965.3744.2718.9198-.074 1.2656l-2.417 2.417 5.7889.0012.1112.0064c.4743.055.8425.4582.8425.9473l-.0074.1196c-.0589.4703-.4601.8341-.9463.8341l-5.7903-.0001 2.4184 2.4183.0793.0898a.9538.9538 0 0 1-1.4281 1.259L2.258 10.6523l-.0713-.0855-.0625-.096-.0471-.0949-.04-.112-.0267-.1234L2 10a.9534.9534 0 0 1 .0104-.1406l.0072-.0422.029-.112.0427-.1088.0349-.0674.0621-.0955.0574-.0702 4.082-4.084Z"
}, void 0), "Switch24Icon", 24);

var Tag16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m4.075 2.8675 3.465-.495a1.2 1.2 0 0 1 1.0181.3395l5.7983 5.7982c.4686.4687.4686 1.2285 0 1.6971l-3.9598 3.9598c-.4686.4686-1.2284.4686-1.697 0L2.9013 8.3688a1.2 1.2 0 0 1-.3394-1.0182l.495-3.4649A1.2 1.2 0 0 1 4.075 2.8675Zm1.4956 2.5138c-.4881.4881-.4881 1.2796 0 1.7677.4882.4882 1.2796.4882 1.7678 0 .4881-.4881.4881-1.2796 0-1.7677-.4882-.4882-1.2796-.4882-1.7678 0Z",
  clipRule: "evenodd"
}, void 0), "Tag16Icon", 16);

var Text24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h5v11c0 .5523.4477 1 1 1s1-.4477 1-1V7h5c.5523 0 1-.4477 1-1s-.4477-1-1-1H6Z",
  clipRule: "evenodd"
}, void 0), "Text24Icon", 24);

var TextColor24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.584 16h-2.752l-.816-2.304H9.632L8.816 16H6.16l4.272-11.344h2.928L17.584 16Zm-4.368-4.608-1.36-3.92-1.392 3.92h2.752Z",
    clipRule: "evenodd"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M18 18H6v2h12v-2Z"
  }, void 0)]
}, void 0), "TextColor24Icon", 24);

var Thick24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M9.831 5.4904c.8231.0934 1.5661-.4982 1.6595-1.3213.0934-.8232-.4981-1.5662-1.3213-1.6596L9.831 5.4904ZM5 12.4999l-1.2862.7718L5 12.4999Zm9-2.5-.186-1.4884L14 9.9999Zm6.7805 10.4735c.8138-.155 1.3479-.9403 1.1929-1.7541-.1551-.8138-.9404-1.3479-1.7542-1.1929l.5613 2.947ZM10.1692 2.5094c-1.6952-.1923-3.154.1705-4.3217.9628-1.147.7782-1.9057 1.8967-2.3647 3.0529-.4584 1.1544-.6431 2.4043-.6063 3.5524.0362 1.1293.2916 2.2847.8374 3.1942l2.5724-1.5436c-.2043-.3404-.3858-.9504-.4113-1.7467-.025-.7774.1038-1.6132.396-2.3492.2916-.7343.7207-1.311 1.2609-1.6775.5193-.3524 1.2467-.5837 2.299-.4643l.3383-2.981ZM3.7139 13.2718c.3254.5423.7446 1.0178 1.2955 1.3371.5683.3294 1.1704.4309 1.7439.3858 1.0316-.0811 2.0103-.6495 2.7494-1.1146.8743-.5502 1.5488-1.0464 2.408-1.5342.8084-.4589 1.5554-.7674 2.2755-.8575l-.3721-2.9768c-1.28.16-2.4235.6799-3.3844 1.2254-.91.5166-1.8836 1.2005-2.5247 1.6039-.7762.4884-1.1801.6467-1.387.663-.0303.0024-.0369-.0007-.0277.0012a.1031.1031 0 0 1 .0212.0071l.0024.0012s-.0012-.0006-.0034-.0022a.1564.1564 0 0 1-.0105-.0078.4548.4548 0 0 1-.044-.0416c-.0402-.0424-.0986-.1151-.1697-.2336l-2.5724 1.5436Zm10.4723-1.7834c.585-.0731.6087.0596.4741-.0433-.1646-.1259-.1063-.2436-.086.035.0207.2841-.0208.7028-.1268 1.3057-.051.2902-.1108.5918-.1754.9205-.0632.322-.1303.6667-.1887 1.013-.1147.6802-.2116 1.4506-.1699 2.1978.0418.7494.2297 1.606.8037 2.3394 1.2071 1.5425 3.3838 1.7274 6.0634 1.217l-.5613-2.947c-2.5703.4896-3.0811-.0442-3.1396-.1189-.0588-.0751-.1482-.2517-.1709-.6576-.0228-.4081.0288-.9151.1328-1.5317.051-.3021.1109-.6108.1743-.9341.0622-.3167.1289-.6526.1863-.979.1108-.6305.2138-1.3623.1642-2.043-.05-.6863-.2768-1.5833-1.084-2.2004-.7771-.594-1.7534-.6645-2.6683-.5502l.3721 2.9768Z"
}, void 0), "Thick24Icon", 24);

var Thin24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M9.8873 4.9935c.5488.0623 1.0441-.332 1.1064-.8808.0623-.5488-.3321-1.0441-.8809-1.1064l-.2255 1.9872ZM5.0001 12.5l-.8575.5146.8575-.5146Zm9-2.5-.124-.9923.124.9923Zm6.687 9.9824c.5425-.1034.8985-.627.7952-1.1695-.1034-.5425-.6269-.8986-1.1695-.7952l.3743 1.9647ZM10.1128 3.0063c-1.588-.1802-2.925.1607-3.9846.8796-1.0458.7096-1.7496 1.7379-2.1807 2.8237-.4307 1.0847-.606 2.2655-.5713 3.3519.0345 1.0738.2776 2.1383.7664 2.953l1.715-1.0291c-.2612-.4353-.455-1.1362-.4824-1.988-.0269-.8392.1112-1.744.4311-2.5497.3195-.8047.8035-1.4716 1.4448-1.9068.6275-.4257 1.4768-.679 2.6362-.5473l.2255-1.9873ZM4.1426 13.0145c.2952.4918.6593.8961 1.1175 1.1617.4698.2724.9684.3581 1.454.3199.8941-.0703 1.777-.5704 2.5223-1.0393.8355-.5257 1.5598-1.0532 2.4275-1.5458.8338-.4733 1.6469-.8171 2.4603-.9188l-.2481-1.9846c-1.1867.1484-2.2641.633-3.1995 1.1641-.9016.5118-1.8254 1.1645-2.5053 1.5923-.77.4845-1.2698.7112-1.614.7383-.1338.0105-.2183-.0124-.2942-.0564-.0874-.0507-.2314-.1704-.4055-.4605l-1.715 1.0291Zm9.9816-2.0223c.64-.08.8224.0423.8398.0556.0067.0051.0228.0175.044.0672.0247.0581.0528.1608.065.3287.0255.3502-.0263.821-.1331 1.4285-.0521.2963-.113.6036-.1771.9303-.0633.3223-.1292.6609-.1864.9999-.1129.6696-.2022 1.3961-.1637 2.0867.0386.6922.2101 1.4354.6982 2.0592 1.0157 1.2978 2.9148 1.5409 5.5762 1.034l-.3743-1.9647c-2.5885.493-3.3769.0174-3.6269-.3019-.1446-.1849-.2505-.4748-.2763-.938-.0259-.4646.0332-1.0154.139-1.6427.0522-.3094.1133-.6241.1767-.9472.0626-.3187.1281-.6489.1844-.9693.11-.6259.2028-1.3055.158-1.9201-.045-.6183-.2438-1.3462-.889-1.8395-.6251-.4779-1.4427-.5587-2.3026-.4512l.2481 1.9845Z"
}, void 0), "Thin24Icon", 24);

var Tiles24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 6c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v12c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V6Zm9 0h5v12h-5v-5.0001h5v-2h-5V6Zm-2 0H6v4.9999h5V6Zm-5 6.9999V18h5v-5.0001H6Z",
  clipRule: "evenodd"
}, void 0), "Tiles24Icon", 24);

var Time24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9Zm.9933-14.1166C12.9355 6.386 12.5128 6 12 6c-.5523 0-1 .4477-1 1v5l.0077.1241c.0358.2863.1942.5457.4376.708l3 2 .1008.059c.4458.2279 1.0015.0903 1.286-.3364l.059-.1008c.2279-.4458.0903-1.0015-.3364-1.286L13 11.464V7l-.0067-.1166Z",
  clipRule: "evenodd"
}, void 0), "Time24Icon", 24);

var TimeHollow24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19 12c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7Zm2 0c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9Zm-8.0067-5.1166C12.9355 6.386 12.5128 6 12 6c-.5523 0-1 .4477-1 1v5l.0077.1241c.0358.2863.1942.5457.4376.708l3 2 .1008.059c.4458.2279 1.0015.0903 1.286-.3364l.059-.1008c.2279-.4458.0903-1.0015-.3364-1.286L13 11.464V7l-.0067-.1166Z",
  clipRule: "evenodd"
}, void 0), "TimeHollow24Icon", 24);

var Timeline24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2",
    d: "M4 5h13.5C19.433 5 21 6.567 21 8.5v0c0 1.933-1.567 3.5-3.5 3.5h-11C4.567 12 3 13.567 3 15.5v0C3 17.433 4.567 19 6.5 19H19"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M17 16.9038c0-.7207.8114-1.1505 1.4172-.7507l3.1769 2.0962c.5412.3571.5412 1.1443 0 1.5014l-3.1769 2.0962c-.6058.3998-1.4172-.03-1.4172-.7507v-4.1924Z"
  }, void 0)]
}, void 0), "Timeline24Icon", 24);

var Transition24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m17.6744 10.2793 4.0819 4.0839.0719.0905.0588.0955.0463.0997.0351.1067.014.0616.015.1118L22 15l-.0103.1405-.0073.0423-.0289.1121-.0304.081-.0361.0749-.0589.0955-.0518.0674-.0556.0607-4.0463 4.0463a.9539.9539 0 0 1-1.4281-1.259l.0793-.0898 2.4183-2.4183-5.7902.0001c-.4862 0-.8874-.3638-.9463-.8341L12 15c0-.4891.3682-.8922.8425-.9473l.1112-.0064 5.7889-.0012-2.417-2.417c-.3458-.3458-.3705-.8912-.0741-1.2656l.0741-.0832a.9538.9538 0 0 1 1.3488 0Zm-10-6 4.0819 4.084.0719.0904.0588.0956.0463.0996.0351.1067.014.0616.015.1118L12 9l-.0103.1405-.0073.0423-.0289.1121-.0304.081-.0361.0749-.0589.0955-.0518.0674-.0556.0607-4.0463 4.0463a.9538.9538 0 0 1-1.4281-1.259l.0793-.0898L8.744 9.9536l-5.7903.0001c-.4862 0-.8874-.3638-.9463-.834L2 9c0-.4891.3682-.8922.8425-.9473l.1112-.0064 5.7889-.0012-2.417-2.417c-.3458-.3458-.3705-.8912-.074-1.2656l.074-.0832a.9537.9537 0 0 1 1.3488 0Z"
}, void 0), "Transition24Icon", 24);

var Triangular24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12.5 5.629-8 13.9999h16l-8-14Zm0 4.031-4.5536 7.969h9.1072L12.5 9.66Z",
  clipRule: "evenodd"
}, void 0), "Triangular24Icon", 24);

var Twitter24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M16.4284 5h2.3615l-5.1591 5.9303L19.7 19h-4.7521l-3.7221-4.8943L6.9669 19H4.604l5.5182-6.3431L4.2999 5h4.8728l3.3645 4.4735L16.4284 5Zm-.8288 12.5785h1.3085L8.4617 6.3469H7.0576l8.542 11.2316Z"
}, void 0), "Twitter24Icon", 24);

var Underline24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M16.492 11.904c0 2.848-2 4.352-4.496 4.352-2.496 0-4.496-1.504-4.496-4.352V4.656h2.528v7.04c0 1.376.768 2.064 1.968 2.064s1.968-.688 1.968-2.064v-7.04h2.528v7.248ZM17 18H7v2h10v-2Z"
}, void 0), "Underline24Icon", 24);

var Undo24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "m6.1153 14.4666-2.0468-3.6925c-.2678-.4831-.0932-1.0917.3898-1.3595.483-.2677 1.0917-.0932 1.3594.3899l.7687 1.3866C7.6686 8.7236 10.133 7 13 7c3.866 0 7 3.134 7 7 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-2.7614-2.2386-5-5-5-2.0864 0-3.8744 1.2779-4.6238 3.0938l1.8497-1.0253c.483-.2678 1.0917-.0933 1.3594.3898.2678.483.0932 1.0917-.3898 1.3594L7.5021 14.865a.9966.9966 0 0 1-.5934.1309.9952.9952 0 0 1-.4295-.142 1.0051 1.0051 0 0 1-.3639-.3873Z"
}, void 0), "Undo24Icon", 24);

var Unlock24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2C8.3431 2 7 3.3432 7 5v6H6c-1.1046 0-2 .8954-2 2v6c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2v-6c0-1.1046-.8954-2-2-2H9V5c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1V5c0-1.6568-1.3431-3-3-3h-4Z",
  clipRule: "evenodd"
}, void 0), "Unlock24Icon", 24);

var Upload24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.0067 14.1166c.0578.4974.4805.8834.9933.8834.5523 0 1-.4477 1-1V6.4148l2.2929 2.2923.0942.0832c.3923.305.9595.2773 1.32-.0832.3905-.3905.3905-1.0237 0-1.4142l-3.9999-4-.0008-.0007a.9991.9991 0 0 0-.092-.0812l-.0014-.0013a.9977.9977 0 0 0-.5975-.2096L12 3a.996.996 0 0 0-.7151.301l-3.992 3.9919-.0832.0942c-.305.3923-.2773.9595.0832 1.32l.0942.0832c.3923.305.9595.2773 1.32-.0832L11 6.4148V14l.0067.1166ZM5 13c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .7601.2673 1.5094.7733 2.0786.5094.573 1.2272.9214 2.0045.9214h12.4444c.7773 0 1.4951-.3484 2.0045-.9214C20.7327 18.5094 21 17.7601 21 17v-4c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .3008-.1073.5689-.2681.7498-.1574.1772-.344.2502-.5097.2502H5.7778c-.1657 0-.3523-.073-.5097-.2502C5.1073 17.5689 5 17.3008 5 17v-4Z",
  clipRule: "evenodd"
}, void 0), "Upload24Icon", 24);

var User24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M12 13c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4Zm-7 5.5C5 16.567 6.567 15 8.5 15h7c1.933 0 3.5 1.567 3.5 3.5V20H5v-1.5Z"
}, void 0), "User24Icon", 24);

var Verified16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.569 15 8 14.4092 10.4311 15l1.4883-2.0393 2.2363-1.1342-.1508-2.5337L15 6.9643 13.2806 5.122l-.7117-2.4333-2.4834-.2892L8 1 5.9145 2.3994l-2.4834.2892-.7117 2.4333L1 6.9642l.9951 2.3285-.1508 2.5337 2.2363 1.1342L5.5689 15Zm6.0384-9.7571a.7693.7693 0 0 0-1.0949.101L7.1697 9.4153l-.9523-.9663-.0732-.0657a.7688.7688 0 0 0-1.0262.0657c-.3037.3082-.3037.808 0 1.1164l1.5548 1.5788.0723.065a.7695.7695 0 0 0 1.0747-.1178l3.8872-4.7366.0578-.08c.2085-.3302.1471-.7742-.1574-1.0318Z",
  clipRule: "evenodd"
}, void 0), "Verified16Icon", 16);

var Verified24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 22.0716 8.1797 23 5.841 19.7953 2.3268 18.013l.237-3.9815L1 10.3725l2.702-2.8953 1.1183-3.8237 3.9025-.4544L12 1l3.2772 2.1991 3.9025.4544 1.1184 3.8237L23 10.3725l-1.5638 3.659.237 3.9815-3.5141 1.7823L15.8203 23 12 22.0716Zm4.7809-12.4469c.345-.4312.2751-1.0605-.1562-1.4055s-1.0606-.2751-1.4056.1561l-4.89 6.1126L8.219 12.305c-.3839-.3971-1.017-.4078-1.414-.024-.3971.3839-.4078 1.017-.024 1.4141l2.9 3a1 1 0 0 0 1.4999-.0704l5.6-7Z",
  clipRule: "evenodd"
}, void 0), "Verified24Icon", 24);

var Video24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 6c0-1.1046-.7163-2-1.6-2H5.6C4.7163 4 4 4.8954 4 6v12c0 1.1046.7163 2 1.6 2h12.8c.8837 0 1.6-.8954 1.6-2V6Zm-9.9991 2.5946C9.5572 8.3274 9 8.6578 9 9.1881v5.6238c0 .5303.5572.8607 1.0009.5935l4.6689-2.8119c.4403-.2651.4403-.9219 0-1.187l-4.6689-2.8119Z",
  clipRule: "evenodd"
}, void 0), "Video24Icon", 24);

var Visible24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 5c4.5455 0 8.4273 2.61 10 7-1.5727 4.39-5.4545 7-10 7-4.5454 0-8.4273-2.61-10-7 1.5727-4.39 5.4546-7 10-7Zm0 2c-2.7556 0-5 2.2444-5 5s2.2444 5 5 5 5-2.2444 5-5-2.2444-5-5-5Zm3 5c0-1.6533-1.3467-3-3-3s-3 1.3467-3 3 1.3467 3 3 3 3-1.3467 3-3Z",
  clipRule: "evenodd"
}, void 0), "Visible24Icon", 24);

var VolumeMute24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.25 8.25 5.4325-3.018C11.4101 4.8277 12 5.1737 12 5.993v12.014c0 .8246-.5872 1.1669-1.3175.7612L5.25 15.75H2.2522c-.4154 0-.7522-.3417-.7522-.7465v-6.007c0-.4122.3284-.7465.7522-.7465H5.25Zm1.5.8826v5.7348l3.75 2.0834V7.0493L6.75 9.1326Zm-1.5.6174H3v4.5h2.25v-4.5Z",
    clipRule: "evenodd"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M15.3483 9.3484a.7501.7501 0 0 0 0 1.0606L16.9393 12l-1.591 1.591a.75.75 0 0 0 1.0607 1.0607L18 13.0607l1.591 1.591a.75.75 0 0 0 1.0606-1.0607L19.0607 12l1.5909-1.591a.75.75 0 1 0-1.0606-1.0606L18 10.9394l-1.591-1.591a.75.75 0 0 0-1.0607 0Z"
  }, void 0)]
}, void 0), "VolumeMute24Icon", 24);

var Warning16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M8 2c-.5523 0-1 .4477-1 1v7c0 .5523.4477 1 1 1s1-.4477 1-1V3c0-.5523-.4477-1-1-1Zm0 12c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
}, void 0), "Warning16Icon", 16);

var WarningTriangle16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m1.1796 12.0114 5.6747-9.3732a1.3337 1.3337 0 0 1 .4883-.4677A1.3512 1.3512 0 0 1 8 2c.2303 0 .4567.0587.6574.1705.2007.1118.3688.2729.4883.4677l5.6747 9.3732a1.315 1.315 0 0 1 .1796.6592c.0006.2315-.06.4591-.1758.6602a1.3327 1.3327 0 0 1-.4846.4861 1.3506 1.3506 0 0 1-.6648.1831H2.3252a1.3504 1.3504 0 0 1-.6648-.1831 1.3321 1.3321 0 0 1-.4846-.4861A1.3147 1.3147 0 0 1 1 12.6706a1.3145 1.3145 0 0 1 .1796-.6592ZM7.3 6a.6667.6667 0 0 1 .6666-.6667h.0667A.6667.6667 0 0 1 8.7 6v2.6666a.6667.6667 0 0 1-.6667.6667h-.0667A.6667.6667 0 0 1 7.3 8.6666V6Zm1.4 5.3334c0 .3682-.3134.6667-.7.6667-.3866 0-.7-.2985-.7-.6667 0-.3682.3134-.6667.7-.6667.3866 0 .7.2985.7.6667Z",
  clipRule: "evenodd"
}, void 0), "WarningTriangle16Icon", 16);

var WarningTriangle24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m2.2565 18.017 8.1068-14.0597a1.9501 1.9501 0 0 1 .6976-.7015A1.8587 1.8587 0 0 1 12 3c.329 0 .6524.088.9391.2558.2867.1677.5269.4093.6976.7015l8.1068 14.0597c.1671.3007.2556.6417.2565.9889a2.05 2.05 0 0 1-.2512.9904 1.9548 1.9548 0 0 1-.6923.7291 1.86 1.86 0 0 1-.9497.2746H3.8932a1.8603 1.8603 0 0 1-.9497-.2746 1.955 1.955 0 0 1-.6923-.7291A2.0493 2.0493 0 0 1 2 19.0059a2.0484 2.0484 0 0 1 .2565-.9889ZM11 9c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V9Zm2 8c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z",
  clipRule: "evenodd"
}, void 0), "WarningTriangle24Icon", 24);

var Wave16Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M3.7329 3.6567a.6281.6281 0 0 1 .1226-.902c.2919-.214.7101-.1572.9342.127L8.239 7.2552c.112.142.3212.1705.467.0635a.314.314 0 0 0 .0614-.451L6.1297 3.5232a.6281.6281 0 0 1 .1227-.902c.2918-.214.71-.1571.9342.127l3.7332 4.7337-.4797-1.7472c-.0946-.3446.1169-.6955.4725-.7838.3556-.0882.7206.1196.8152.4642.7124 2.5948 2.4459 6.015-.2851 8.0176-1.751 1.284-4.2606.9428-5.6053-.7622l-3.652-4.6307a.6281.6281 0 0 1 .1227-.902c.2918-.214.71-.1572.9342.127L5.0683 9.58c.112.1421.3212.1706.467.0636a.314.314 0 0 0 .0614-.451L2.9591 5.8482a.6281.6281 0 0 1 .1227-.902c.2918-.214.7101-.1571.9342.127l2.3332 2.9586c.112.142.3212.1705.4672.0635a.314.314 0 0 0 .0613-.451L3.7329 3.6567Z"
}, void 0), "Wave16Icon", 16);

var Wave24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M5.5993 5.485c-.3361-.4263-.2538-1.032.184-1.353.4378-.3211 1.0652-.2358 1.4013.1905l5.1737 6.5602c.1681.2131.4818.2558.7007.0952a.471.471 0 0 0 .092-.6765L9.1946 5.2848c-.3361-.4263-.2538-1.032.184-1.353.4378-.321 1.0652-.2357 1.4013.1905l5.5998 7.1005-.7196-2.6208c-.1419-.5169.1754-1.0433.7088-1.1756.5334-.1324 1.0809.1793 1.2228.6963 1.0686 3.8921 3.6688 9.0224-.4276 12.0263-2.6266 1.9261-6.391 1.4142-8.408-1.1433l-5.478-6.9461c-.3361-.4262-.2538-1.032.184-1.353.4378-.321 1.0652-.2357 1.4013.1905l2.739 3.4731c.1681.2131.4818.2557.7007.0952a.471.471 0 0 0 .092-.6765L4.4387 8.7723c-.3361-.4263-.2538-1.032.184-1.353.4378-.321 1.0652-.2358 1.4013.1905l3.4999 4.4378c.168.2131.4818.2558.7006.0953a.4712.4712 0 0 0 .092-.6766L5.5993 5.485Z"
}, void 0), "Wave24Icon", 24);

var Webcast24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    fill: "currentColor",
    d: "M15.3863 4.094c.3817-.3993 1.0147-.4135 1.4139-.0319C18.9567 6.1237 20.2 8.9711 20.2 12.0143c0 3.0251-1.2284 5.8569-3.3623 7.9162-.3974.3835-1.0305.3722-1.414-.0252-.3835-.3974-.3722-1.0305.0252-1.414 1.7472-1.6861 2.7511-4.0004 2.7511-6.477 0-2.4915-1.0161-4.8185-2.7819-6.5065-.3992-.3816-.4134-1.0146-.0318-1.4138Z"
  }, void 0), jsx("path", {
    fill: "currentColor",
    d: "M12.5729 6.9521c.3777-.403 1.0106-.4234 1.4135-.0457C15.3886 8.2208 16.2 10.0538 16.2 12.0143c0 1.96-.811 3.7925-2.2125 5.1069-.4029.3778-1.0357.3574-1.4135-.0454-.3778-.4029-.3575-1.0357.0454-1.4135 1.0024-.9401 1.5806-2.2466 1.5806-3.648 0-1.4018-.5785-2.7086-1.5814-3.6487-.4029-.3777-.4234-1.0106-.0457-1.4135ZM4.836 16.8187l6.1358-3.8083a1.1946 1.1946 0 0 0 .3816-.3789c.3513-.5581.1804-1.2933-.3816-1.6421L4.836 7.1811A1.2062 1.2062 0 0 0 4.2 7C3.5373 7 3 7.5335 3 8.1917v7.6165c0 .2233.0632.4422.1824.6316.3513.5581 1.0916.7277 1.6536.3789Z"
  }, void 0)]
}, void 0), "Webcast24Icon", 24);

var Whiteboard24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m10.4339 4.4956 3.7169 3.7169 1.239-1.239a.8762.8762 0 0 0 0-1.239l-2.478-2.4779a.8761.8761 0 0 0-1.239 0l-1.2389 1.239Zm-7.1773 7.1772A.8762.8762 0 0 0 3 12.2923v2.478a.876.876 0 0 0 .876.8761h2.478a.876.876 0 0 0 .6195-.2566l5.9383-5.9383-3.717-3.717-5.9382 5.9383ZM15.7 16.9332c-.1397-.1764-.3544-.3617-.8647-.4468a3.0297 3.0297 0 0 0-.2857-.0343c-.6287-.0445-1.0838.1411-1.5099.4469-.3997.2868-.7207.6286-1.1104 1.0436-.1783.1899-.3711.3952-.5923.6175-.6416.6446-1.4664 1.3504-2.6332 1.6113-.4182.0935-.8573.1252-1.3224.091-.8468-.0624-1.7795-.3434-2.8287-.868-.494-.247-.6942-.8477-.4472-1.3416a1.0003 1.0003 0 0 1 .9675-.5504.9971.9971 0 0 1 .3743.1032c.8886.4443 1.5637.6251 2.0871.6623.2862.0203.5271-.0023.7328-.0483.595-.133 1.0842-.4998 1.652-1.0704.1273-.1279.2664-.2759.4154-.4345l.0004-.0001h-.0002v-.0001c.4415-.4699.9702-1.0325 1.5386-1.4404.748-.5368 1.6493-.8926 2.788-.819.0712.0046.1433.0109.2163.0189.094.0103.1895.0235.2867.0396.9897.165 1.6499.6047 2.104 1.1783.3047.385.5269.8733.6635 1.1735h-.0002l.0003.0001c.0346.0762.0638.1402.0874.1874.1453.2906.2015.2985.2154.3005l.0021.0004h.0002a.4326.4326 0 0 0 .0836.0143.7457.7457 0 0 0 .0408.0025c.186.0066.5688-.0375 1.2871-.3068a.9956.9956 0 0 1 .4194-.0616 1 1 0 0 1 .8682.6468c.1939.5171-.0681 1.0935-.5852 1.2874-.7843.2941-1.4797.4603-2.0943.4314a2.6872 2.6872 0 0 1-.2489-.0232 2.349 2.349 0 0 1-.3391-.0732c-.8348-.2474-1.2188-.8848-1.4384-1.3241-.0862-.1724-.1503-.3128-.2054-.4333v-.0001c-.1101-.241-.1838-.4025-.3249-.5807Z",
  clipRule: "evenodd"
}, void 0), "Whiteboard24Icon", 24);

var Youtube24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  d: "M22.5467 6.5036c-.2535-.979-.9966-1.7507-1.9389-2.0143C18.8862 4 11.9998 4 11.9998 4s-6.8862 0-8.6078.4707c-.9242.2634-1.6854 1.054-1.939 2.033C1 8.2916 1 12 1 12s0 3.727.453 5.4964c.2538.9788.9967 1.7506 1.9392 2.0142C5.1317 20 12 20 12 20s6.8862 0 8.6078-.4707c.9424-.2635 1.6854-1.0352 1.9392-2.0141.4529-1.7882.4529-5.4964.4529-5.4964s.0181-3.727-.4532-5.5152ZM9.8073 15.4258V8.5742L15.5337 12l-5.7264 3.4258Z"
}, void 0), "Youtube24Icon", 24);

var ZipFile24Icon = createSvgIcon(jsx("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 2c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h12c1.1046 0 2-.8954 2-2V7.8284a2 2 0 0 0-.5858-1.4142l-3.8284-3.8284A2 2 0 0 0 14.1716 2H6Zm8.3657 2.3657c-.504-.504-1.3657-.147-1.3657.5657V8.2a.8.8 0 0 0 .8.8h3.2686c.7128 0 1.0697-.8617.5657-1.3657l-3.2686-3.2686ZM7 5h2v2H7V5Zm2 4H7v2h2V9Zm-2 4h2v2H7v-2Zm3 4H6v2h4v-2Z",
  clipRule: "evenodd"
}, void 0), "ZipFile24Icon", 24);

var Zoomin24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "m14.2181 14.2181 4.8809 4.8809"
  }, void 0), jsx("circle", {
    cx: "10",
    cy: "10",
    r: "6",
    stroke: "currentColor",
    "stroke-width": "2"
  }, void 0), jsx("rect", {
    width: "6",
    height: "2",
    x: "7",
    y: "9",
    fill: "currentColor",
    rx: "1"
  }, void 0), jsx("rect", {
    width: "6",
    height: "2",
    x: "11",
    y: "7",
    fill: "currentColor",
    rx: "1",
    transform: "rotate(90 11 7)"
  }, void 0)]
}, void 0), "Zoomin24Icon", 24);

var Zoomout24Icon = createSvgIcon(jsxs(React.Fragment, {
  children: [jsx("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "m14.2181 14.2181 4.8809 4.8809"
  }, void 0), jsx("circle", {
    cx: "10",
    cy: "10",
    r: "6",
    stroke: "currentColor",
    "stroke-width": "2"
  }, void 0), jsx("rect", {
    width: "6",
    height: "2",
    x: "7",
    y: "9",
    fill: "currentColor",
    rx: "1"
  }, void 0)]
}, void 0), "Zoomout24Icon", 24);

export { Add24Icon, AddContact24Icon, Alert24Icon, Analytics24Icon, Announcement24Icon, ArrowDown24Icon, ArrowLeft24Icon, ArrowRight24Icon, ArrowUp24Icon, Banner24Icon, Blur24Icon, Bold24Icon, Bolt24Icon, Bookmark16Icon, Breakout24Icon, Bulletlist24Icon, BusinessCard16Icon, Calendar24Icon, Camera24Icon, CameraOff24Icon, Captions24Icon, Chat24Icon, Check16Icon, Check24Icon, ChevronDown16Icon, ChevronDown24Icon, ChevronLeft16Icon, ChevronLeft24Icon, ChevronRight16Icon, ChevronRight24Icon, ChevronUp16Icon, ChevronUp24Icon, Chrome24Icon, Circle24Icon, Clean24Icon, Clear24Icon, Clip24Icon, Close16Icon, Coffee24Icon, CollapseMenu24Icon, Contrast24Icon, Copy24Icon, CreditCard24Icon, Cursor24Icon, Delete24Icon, Document24Icon, Dotgrid24Icon, DoubleChevronDown16Icon, DoubleChevronLeft24Icon, DoubleChevronRight24Icon, Download24Icon, Edge24Icon, Edit24Icon, Embed24Icon, Emoji24Icon, Erazer24Icon, Excel24Icon, Executives24Icon, Exit24Icon, Expand16Icon, Expand24Icon, ExpandMenu24Icon, Expert24Icon, ExternalLink16Icon, ExternalLink24Icon, Facebook24Icon, Feedback24Icon, File24Icon, Filter24Icon, Firefox24Icon, FitFrame24Icon, FloatingView24Icon, Folder24Icon, Formal24Icon, FreeText24Icon, GenAI24Icon, GeneralSpinner16Icon, Github24Icon, Globe16Icon, Globe24Icon, GridView24Icon, Group24Icon, Hand24Icon, Help24Icon, Image24Icon, Info24Icon, InformativeGallery24Icon, Instagram24Icon, Integrations24Icon, InteractiveRoom24Icon, Internet24Icon, Invisible24Icon, Italic24Icon, Keylines24Icon, Laser24Icon, Light24Icon, Like24Icon, LikeHollow24Icon, Line24Icon, Linegrid24Icon, Link16Icon, Link24Icon, LinkedIn24Icon, LiveBroadcast24Icon, Lock16Icon, Lock24Icon, Mail24Icon, Marker24Icon, Martini24Icon, Menu24Icon, Microphone16Icon, Microphone24Icon, MicrophoneMuted16Icon, MicrophoneMuted24Icon, Minimize24Icon, Minus24Icon, Mobile24Icon, MoreHorizontal24Icon, MoreVertical24Icon, NoAccess24Icon, None24Icon, Notes24Icon, Notification24Icon, OrderedList24Icon, Partial16Icon, Pause24Icon, Pdf24Icon, Pencil24Icon, Phone24Icon, Pin24Icon, Play24Icon, Playlist24Icon, Plus16Icon, Poll24Icon, PopOut16Icon, PopOut24Icon, Post24Icon, Presenter24Icon, Privacy24Icon, QR24Icon, QuestionMark16Icon, QuestionMark24Icon, Quiz24Icon, Record24Icon, RecordOn24Icon, Recyclebin24Icon, Redo16Icon, Redo24Icon, Refresh24Icon, Remove24Icon, Resolved24Icon, RightHand24Icon, Score24Icon, Search24Icon, SelfServedLive24Icon, Settings24Icon, Shape24Icon, Shapefull24Icon, Share24Icon, ShareScreen24Icon, ShareScreenClose24Icon, Shuffle24Icon, SideBySide16Icon, SideBySide24Icon, Sidebar24Icon, SidebarBottom24Icon, SidebarLeft24Icon, SidebarRight24Icon, Simulive24Icon, Slack24Icon, Slide24Icon, Sound24Icon, Speaker24Icon, SpeakerMuted24Icon, SpeakerView24Icon, Speed24Icon, Split24Icon, StackOverflow24Icon, Stage24Icon, StarFull24Icon, StarHollow24Icon, Stop24Icon, Subscribe24Icon, Subscribed24Icon, Switch24Icon, Tag16Icon, Text24Icon, TextColor24Icon, Thick24Icon, Thin24Icon, Tiles24Icon, Time24Icon, TimeHollow24Icon, Timeline24Icon, Transition24Icon, Triangular24Icon, Twitter24Icon, Underline24Icon, Undo24Icon, Unlock24Icon, Upload24Icon, User24Icon, Verified16Icon, Verified24Icon, Video24Icon, Visible24Icon, VolumeMute24Icon, Warning16Icon, WarningTriangle16Icon, WarningTriangle24Icon, Wave16Icon, Wave24Icon, Webcast24Icon, Whiteboard24Icon, Youtube24Icon, ZipFile24Icon, Zoomin24Icon, Zoomout24Icon };
